// 2024-10-07T09:50:19.857Z  (1728294619857)
export const locale = {
	lang: 'es',
	data: {
		'ACCOUNTING_VALUE': 'Valor contable',
		'ACCOUNTING_VALUES': 'Valores añadidos',
		'ACCOUNTING_VALUE.COMPUTE_IN_STATES': 'Cálculo sólo en estados de trabajo seleccionados',
		'ACCOUNTING_VALUE.VALUE_AGGREGATION': 'Valor Agregado ',
		'ACCOUNTING_VALUE.VALUE_COMPUTATION': 'Cálculo de valor',
		"ACCOUNTING_VALUE.RESOURCE_TYPE": "Tipo de recurso operativo",
		'ACCOUNTING_VALUE.VALUE_SUMMATION': 'Suma de valor',
		'ACCOUNT_ACTIVATION': 'Activación de cuenta',
		'ACCOUNT_ACTIVATION.CODE': 'Código de activación',
		'ACCOUNT_ACTIVATION.CODE.RESEND': 'Re-envío de código de activación',
		'ACCOUNT_ACTIVATION.INTRO': 'Por favor, ingrese el código recibido en su mail',
		'ACID': 'Ácido',
		'ACTIVATE': 'Activar',
		'ACTIVATE.SELECTED': 'Activo seleccionado',
		'ACTIVE': 'Activo',
		'ACTIVITIES.DAILY': 'Actividades diarias',
		'ACTIVITIES.EXPORT': 'Exportar actividades',
		'ACTIVITIES.NO': 'No actividades',
		'ACTIVITIES.WEEKLY': 'Actividades semanales',
		'ACTIVITY': 'Actividad',
		'ACTIVITY.EXPORT_DETAILS': 'Exporte la actividad seleccionada',
		'ACTIVITY.NO_FIELDS_WORKED': 'Ningún trabajo realizado en campos conocidos',
		'ADAPTER': 'Módulo',
		'ADAPTER.ASSIGN': 'Asignar módulo',
		'ADAPTER.ASSIGN.FAILURE': 'Error en la asignación del módulo',
		'ADAPTER.ASSIGN.SUCCESS': 'Módulo asignado correctamente',
		'ADAPTER.ASSIGNED_MACHINE': 'Máquina asignada',
		'ADAPTER.ASSIGNMENT': 'Asignación de los módulos a las máquinas',
		'ADAPTER.CHOSEN': 'Módulo seleccionado',
		'ADAPTER.LOAD.FAILURE': 'Error al cargar los módulos',
		'ADAPTER.NO': 'Sin módulo',
		'ADAPTER.NONE_AVAILABLE': 'Módulo no disponible',
		'ADAPTER.PAIR_INFO': 'Seleccione el módulo correspondiente. Los módulos ya asignados se sobrescribirán con la nueva máquina. La nueva configuración se cargará automáticamente con el próximo reinicio del módulo.',
		'ADAPTER.PREVIOUS': 'Módulo previo',
		'ADAPTERS.NO': 'Sin módulos',
		'ADBLUE.LEVEL': 'Nivel AdBlue',
		'ADD': 'Agregar',
		'ADDITIONAL_VALUE': 'Valor agregado',
		'ADDITIVE': 'Aditivo',
		'ADDRESS': 'Dirección',
		'ALL': 'Todo',
		'ALL_DEVICES': 'Dispositivos generales',
		'AMOUNT': 'Cantidad',
		'AMOUNT.INVALID': 'Cantidad Inválida',
		'AMOUNTS': 'Cantidad',
		'APPLY': 'Aplicar',
		'ARCHIVE': 'Archivo',
		'ARCHIVE.SELECTED': 'Archivo seleccionado',
		'AREA': 'Superficie',
		'AREA.FIELD': 'Superficie ',
		'AREA.LOCATION': 'Localizaciones',
		'AREA.PERFORMANCE': 'Área por h',
		'AREA.PROCESSED': 'Área procesada',
		'AREA.TOTAL': 'Superficie total',
		'AREA.WORKED': 'Superficie trabajada',
		'ASSIGN': 'Asignar',
		'AUTH.REMEMBER_ME': 'Recordarme',
		'BACK': 'Atrás',
		'BALES': 'Bales',
		'BASIC_DATA': 'Datos básicos',
		'BEACON': 'Beacon',
		'BEACON.ASSIGN': 'Asignar baliza',
		'BEACON.ASSIGN.SUCCESS': 'Beacon asignado con éxito',
		'BEACON.ASSIGNED_EMPLOYEE': 'Empleado asignado',
		'BEACON.ASSIGNED_IMPLEMENT': 'Implemento asignado',
		'BEACON.ASSIGN_TO_EMPLOYEE': 'Asignar beacon al empleado',
		'BEACON.ASSIGN_TO_IMPLEMENT': 'Asignar beacon al implemento',
		'BEACON.CHOSEN': 'Beacon elegido',
		'BEACON.ERROR': 'Error al asignar el beacon',
		'BEACON.LOAD_ERROR': 'Error al cargar el beacon',
		'BEACON.NONE_AVAILABLE': 'No beacon disponible',
		'BEACON.NO_BEACON': 'Sin beacon',
		'BEACON.PAIR_INFO_EMPLOYEE': 'Seleccione el correspondiente beacon. Los beacon ya asignadas se sobreescribirán con el nuevo empleado.',
		'BEACON.PAIR_INFO_IMPLEMENT': 'Seleccione el correspondiente beacon. Los beacons ya asignadas se sobreescribirán con el nuevo implemento.',
		'BEACON.PREVIOUS': 'Beacon previo',
		'BEACONS': 'Beacons',
		'BUILD_YEAR': 'Año de construcción',
		'BUILD_YEAR.INVALID': 'Año de construcción inválido',
		'CAN.STATUS': 'CAN estatus',
		'CANCEL': 'Cancelar',
		'CHANGE': 'Cambiar',
		'CHANGE.NO': 'Sin cambios',
		'CHOOSE_ALL': 'Elegir todos',
		'CHOOSE_ROLE': 'Elegir roles',
		'CHRONOLOGICAL': 'Orden cronológico',
		'CLICK_PROCESS': 'Elegir un proceso para más detalles',
		'CLOSE': 'Cerrar',
		'CO2.EMISSION': 'Emisiones de CO2',
		'CO2.PER': 'CO2 por hectárea',
		'CO2.TOTAL': 'Cantidad total de CO2',
		'COLOR': 'Color',
		'COMMENT': 'Comentario',
		'CONDITION': 'Condición',
		'CONFIRM': 'Confirmar',
		'CONFIRM_PASSWORD': 'Confirmar contraseña',
		'CONNECT': 'Conectar',
		'CONTACT_PERSON': 'Nombre de la persona',
		'CONTINUE': 'Continuar',
		'COST': 'Costo',
		'COST.INVALID': 'Costo inválido',
		'COST.OVERALL': 'Costo total',
		'COST.OVERALL.ARRIVAL': 'Costo total de llegada',
		'COST.OVERALL.DRIVER': 'Costo total del conductor',
		'COST.OVERALL.FIELD_TIME': 'Coste total del campo',
		'COST.OVERALL.IMPLEMENTS': 'Costo total de implementos',
		'COST.OVERALL.MACHINES': 'Costo total de maquinaria',
		'COST.OVERALL.PREPARATION': 'Costo totales de preparación',
		'COST.TOTAL': 'Costo total',
		'COSTS': 'Costos',
		'COST_RATE': 'Tasa de costo',
		'COUNTRY': 'País',
		'COVERAGE': 'Coverage',
		'COVERAGE.MAP': 'Mapa de cobertura',
		'COVERAGE.MAP.SETTINGS': 'Ajustes del mapa de cobertura',
		'COVERAGE.MAP.ZONES': 'Zonas',
		'CREATED': 'Creado',
		'CREATE_USER': 'Crear usuario',
		"CROP": "Cultivo",
		'CROP.TYPE': 'Tipo de cultivo',
		'CROP.NO_CROP': 'Sin cultivo',
		'CURRENCY': 'Moneda',
		'CUSTOMER': 'Cliente',
		'CUSTOMER.ADD': 'Agregar nuevo cliente',
		'CUSTOMER.ADD.SUCCESS': 'Cliente agregado correctamente',
		'CUSTOMER.ASSIGN': 'Asigar cliente',
		'CUSTOMER.DELETE.QUESTION': '¿Confirma que quiere eliminar el cliente?',
		'CUSTOMER.DELETE.SUCCESS': 'El cliente ha sido eliminado',
		'CUSTOMER.DETAILS': 'Detalles de cliente',
		'CUSTOMER.EDIT': 'Editar cliente',
		'CUSTOMER.EDIT.SUCCESS': 'Cliente editado correctamente',
		'CUSTOMER.NAME': 'Nombre de cliente',
		'CUSTOMER.NO': 'Sin cliente',
		'CUSTOMER.NOT_SELECTED': 'Ningún cliente seleccionado',
    'CUSTOMER.NO.ASSIGNEE': 'Sin cliente asignado',
		'CUSTOMER.SELECT': 'Seleccionar cliente',
		'CUSTOMERS': 'Clientes',
		'CUSTOMERS.ALL': 'Todos los clientes',
		'CUSTOMERS.DELETE.FAILURE': 'Algunos clientes no pudieron ser seleccionados',
		'CUSTOMERS.DELETE.QUESTION': '¿Desea eliminar los clientes seleccionados?',
		'CUSTOMERS.DELETE.SUCCESS': 'Clientes eliminados correctamente',
		'CUSTOMERS.MANAGEMENT': 'Gestión de clientes',
		'CUSTOMERS.NO': 'No hay clientes',
		'CUSTOMERS.SELECTED': 'Clientes seleccionados',
		'CUSTOM_LABELING': 'Etiquetado personalizado',
		'CUSTOM_LABELING.ADD_WORKSTATE': 'Añadir nuevo estado de trabajo',
		'CUSTOM_LABELING.DEFINE_FOR_IMPLEMENT': 'Definir un etiquetado personalizado para el implemento seleccionado',
		'CUSTOM_LABELING.DEFINE_INDIVIDUAL_CONDITION': 'Definir condiciones individuales para la etiqueta',
		'CUSTOM_LABELING.EDIT.SUCCESS': 'Editar con éxito el etiquetado personalizado',
		'CUSTOM_LABELING.INDIVIDUAL_CONDITION': 'Condición individual',
		'CUSTOM_LABELING.ISOBUS_OVERRIDE': 'Permitir la anulación con condiciones ISOBUS',
		'CUSTOM_LABELING.NO_LABELS_AVAILABLE': 'No hay etiquetas disponibles',
		'DASHBOARD.GPS_DATA.NO': 'Sin datos de GPS',
		'DASHBOARD.MACHINE_POSITIONS.LOAD.FAILURE': 'Error al cargar la posición de la maquinaria',
		'DATA': 'Data',
		'DATA.ARCHIVED.WARNING': 'Los datos subyacentes están parcial o totalmente archivados',
		'DATA.EXPORT': 'Exportar data',
		'DATA.INPUT': 'Data input',
		'DATA.UPDATING.WARNING': 'Se actualizan los datos subyacentes',
		'DATA_PREPARATION': 'Preparación de datos',
		'DATE': 'Fecha',
		'DATE.APRIL': 'Abril',
		'DATE.AUGUST': 'Agosto',
		'DATE.DECEMBER': 'Diciembre',
		'DATE.FEBRUARY': 'Febrero',
		'DATE.FRIDAY': 'Viernes',
		'DATE.FROM': 'Desde',
		'DATE.JANUARY': 'Enero',
		'DATE.JULY': 'Julio',
		'DATE.JUNE': 'Junio',
		'DATE.MARCH': 'Marzo',
		'DATE.MAY': 'Mayo',
		'DATE.MONDAY': 'Lunes',
		'DATE.NOVEMBER': 'Noviembre',
		'DATE.OCTOBER': 'Octubre',
		'DATE.PERIOD': 'Período',
		'DATE.RANGE': 'Intervalo de fechas',
		'DATE.SATURDAY': 'Sábado',
		'DATE.SEPTEMBER': 'Septiembre',
		'DATE.SUNDAY': 'Domingo',
		'DATE.THURSDAY': 'Jueves',
		'DATE.TUESDAY': 'Martes',
		'DATE.UNTIL': 'Hasta',
		'DATE.WEDNESDAY': 'Miércoles',
		'DAY.CURRENT': 'Día actual',
		'DAY.NEXT': 'Próximo día',
		'DAY.PREVIOUS': 'Día previo',
		'DAY.SELECTED': 'Día seleccionado',
		'DAYS': 'Días',
		'DAY_ACTIVITIES': 'Actividades diarias',
		'DEACTIVATE': 'Desactivar',
		'DEACTIVATE.SELECTED': 'Desactivar seleccionado',
		'DEADLINE': 'Fecha límite',
		'DEADLINE.ADD': 'Añadir fecha límite',
		'DEADLINE.ADD.SUCCESS': 'Fecha límite añadida con éxito',
		'DEADLINE.DELETE.SUCCESS': 'Fecha límite',
		'DEADLINE.DONE': 'Finalizado',
		'DEADLINE.DUE': 'Fecha límite',
		'DEADLINE.DUE_IN_AT': 'Vence en ',
		'DEADLINE.EDIT': 'Plazo de edición',
		'DEADLINE.EDIT.SUCCESS': 'La fecha tope ha sido editada',
		'DEADLINE.IS_CLOSE': 'Esta fecha tope se acerca',
		'DEADLINE.IS_OVERDUE': 'Fecha límite vencida',
		'DEADLINE.OPEN': 'Abrir',
		'DEADLINE.PROCESS.SUCCESS': 'Plazo tramitado con éxito',
		'DEADLINE.PROCESSED': 'Procesado',
		'DEADLINE.PROCESSED.SUCCESS': 'Fecha tope procesada correctamente',
		'DEADLINE.WARN': 'Fecha límite llegando',
		'DEADLINES': 'Fecha tope',
		'DEADLINES.NO': 'Sin fecha tope',
		'DEFINE_ROLE': 'Definir rol',
		'DELETE': 'Eliminar',
		'DELETE.SELECTED': 'Eliminar selecionados',
		'DELETED': 'Eliminado',
		'DESCRIPTION': 'Descripción',
		'DIAGRAM': 'Diagrama',
		'DISPLAY': 'Mostrar',
		'DISPLAY_TRACK': 'Mostrar track ',
		'DISTANCE': 'Distancia',
		'DISTANCE.TOTAL': 'Distancia total',
		'DISTANCE.WORKED': 'Distancia trabajada',
		'DOWNLOAD': 'Descargar',
		'DRIVER': 'Conductor',
		'DRIVER.EDIT': 'Editar conductor',
		'DRIVER.FIXED': 'Conductor fijo',
		'DRIVER.NO': 'Sin conductor',
		'DRIVER.REMOVE': 'Remover conductor',
		'DRIVERS': 'Conductores',
		'DRIVERS.ALL': 'Todos los conductores',
		'DRIVER_SCAN_DISABLED': 'Inactivar beacon de conductor',
		'DURATION': 'Duración',
		'DURATION.WORKED': 'Duración del trabajo',
		'EDIT': 'Editar',
		'EDIT.SELECTED': 'Editar ',
		'EDIT_USER': 'Editar usuario',
		'EMAIL': 'Correo electrónico de contacto',
		'EMAIL.ACTIVATE': 'Activar correo electrónico',
		'EMAIL.ACTIVATE.CODE': 'Código de activación',
		'EMAIL.ACTIVATE.EXPLANATION': 'Si modifica su dirección de correo electrónico se le enviará un mail de confirmación',
		'EMAIL.CHANGE': 'Modificar correo electrónico',
		'EMAIL.CHANGE.SUCCESS': 'Correo electrónico correctamente modificado',
		'EMAIL.CONFIRM': 'Confirmar correo electrónico',
		'EMAIL.CURRENT': 'Correo electrónico actual',
		'EMAIL.INVALID': 'Correo electrónico no válido',
		'EMAIL.NEW': 'Nuevo correo electrónico',
		'EMAIL.NO_MATCH': 'Los correos electrónicos no coinciden',
		'EMPLOYEE': 'Empleado',
		'EMPLOYEE.ACTIVATE.QUESTION': '¿De verdad quieres activar al empleado?',
		'EMPLOYEE.ADD': 'Añadir empleado',
		'EMPLOYEE.ADD.SUCCESS': 'Empleado agregado correctamente',
		'EMPLOYEE.CREATE': 'Crear empleado',
		'EMPLOYEE.CREATE.SUCCESS': 'Empleado creado con éxito',
		'EMPLOYEE.DEACTIVATE.QUESTION': '¿Realmente quieres desactivar al empleado?',
		'EMPLOYEE.DELETE.QUESTION': '¿De verdad quieres echar al empleado?',
		'EMPLOYEE.EDIT': 'Editar empleado',
		'EMPLOYEE.EDIT.SUCCESS': 'Empleado editado correctamente',
		'EMPLOYEE.ROLE': 'Rol de empleado',
		'EMPLOYEE.ROLE_OF': 'Rol del empleado',
		'EMPLOYEES': 'Empleados',
		'EMPLOYEES.ACTIVATE.QUESTION': '¿Realmente quiere activar a los empleados?',
		'EMPLOYEES.ACTIVATE.SUCCESS': 'Empleados activados con éxito',
		'EMPLOYEES.ALL': 'Todos los empleados',
		'EMPLOYEES.DEACTIVATE.FAILURE': 'Algunos de los empleados no pudieron ser desactivados.',
		'EMPLOYEES.DEACTIVATE.QUESTION': '¿Realmente desea desactivar a los empleados seleccionados?',
		'EMPLOYEES.DEACTIVATE.SUCCESS': 'Los empleados han sido desactivados',
		'EMPLOYEES.DELETE.FAILURE': 'Algunos de los empleados no pudieron ser eliminados.',
		'EMPLOYEES.DELETE.QUESTION': '¿Realmente desea eliminar los empleados seleccionados?',
		'EMPLOYEES.DELETE.SUCCESS': 'Empleados eliminados',
		'EMPLOYEES.MANAGEMENT': 'Gestión de empleados',
		'EMPLOYEES.NO': 'No hay empleados',
		'EMPLOYEES.NOT_SELECTED': 'Ningún empleado seleccionado',
		'EMPLOYEES.SELECTED': 'Empleados seleccionados',
		'EMPLOYER.NO': 'Ningún empleador',
		'EMPLOYER.NOT_SELECTED': 'Ningún empleador seleccionado',
		'EMPLOYES.NO': 'No hay empleados',
		'END_DRAW_MODE': 'Modo de dibujo cancelado',
		'ENTERPRISE': 'Empresa',
		'ENTERPRISE.ADD': 'Añadir empresa',
		'ENTERPRISE.ADD.EMPLOYER_REQUIRED': 'Necesita añadir un empleador',
		'ENTERPRISE.ADD.SUCCESS': 'Añadido con éxito a la empresa',
		'ENTERPRISE.ADDED.SUCCESS': 'Empresa adicionada com sucesso',
		'ENTERPRISE.ENTER_ACCESS_TOKEN': 'Introduzca el código de acceso de la empresa.',
		'ENTERPRISE.NAME': 'Nombre de la empresa',
		'ENTERPRISE.NOT_SELECTED': 'Ninguna empresa seleccionada',
		'ENTERPRISE.OF': 'Empresa de:',
		'ENTERPRISE.SETTINGS': 'Configuración de la empresa',
		'ENTERPRISE.SETTINGS.CONFIGURATION_UPDATE.SUCCESS': 'Configuración de la empresa actualizada correctamente',
		'ENTERPRISE.SETTINGS.MACHINES_SYNC.SUCCESS': 'Máquinas sincronizadas correctamente',
		'ENTERPRISE_LICENSE.EMPLOYEES': 'Licencias para empleados',
		'ENTERPRISE_LICENSE.LICENSE': 'Licencia',
		'ENTERPRISE_LICENSE.MACHINE': 'Licencia de máquina',
		'ENTERPRISE_LICENSE.MACHINES': 'Licencias de máquinas',
		'ENTERPRISE_MIN': 'El nombre de la empresa debe contener al menos 3 caracteres',
		'ENTERPRISE_NAME_REQUIRED': 'Se requiere el nombre de la empresa',
		'ENTERPRISE_SELECTION.ADD_ENTERPRISE': 'Añadir empresa',
		'ENTERPRISE_SELECTION.LICENSE_EXPIRED': 'Licencia caducada',
		'ENTERPRISE_SELECTION.REQUEST_TEST_ACCOUNT': 'Solicitar cuenta de prueba',
		'ENTERPRISE_STATISTICS': 'Estadísticas de empresa',
		'ENTERPRISE_STATISTICS.COST_DIAGRAMM': 'Diagrama de costes',
		'ENTERPRISE_STATISTICS.PROCESS_DIVISION': 'División de procesos',
		'ENUM.ACCOUNTING_COMP_MODE.A': 'Todos',
		'ENUM.ACCOUNTING_COMP_MODE.WT': 'Trabajando / Transportando',
		'ENUM.ACCOUNTING_MODE.AVG': 'Promedio',
		'ENUM.ACCOUNTING_MODE.MAX': 'Máximo',
		'ENUM.ACCOUNTING_MODE.MED': 'Mediana',
		'ENUM.ACCOUNTING_MODE.MIN': 'Mínimo',
		'ENUM.ACCOUNTING_MODE.SUM': 'Suma',
		'ENUM.ACCOUNTING_VALUE_MODE.ABSDIF': 'Diferencia ',
		'ENUM.ACCOUNTING_VALUE_MODE.DIR': 'Directo',
		'ENUM.ACCOUNTING_VALUE_MODE.NEGDIF': 'Diferencia negativa',
		'ENUM.ACCOUNTING_VALUE_MODE.POSDIF': 'Diferencia positiva',
		'ENUM.ACCOUNTING_VALUE_MODE.TIMACT': 'Tiempo activo',
		'ENUM.BEACONTYPE.BDrv': 'Beacon del conductor',
		'ENUM.BEACONTYPE.BImpl': 'Implementar beacon',
		'ENUM.CAN_IDENTIFIER.A1': 'IO-Box: Analógico 1',
		'ENUM.CAN_IDENTIFIER.A2': 'IO-Box: Analógico 2',
		'ENUM.CAN_IDENTIFIER.A3': 'IO-Box: Analógico 3',
		'ENUM.CAN_IDENTIFIER.A4': 'IO-Box: Análogo 4',
		'ENUM.CAN_IDENTIFIER.AUX0_Ext_Fl': 'AUX0 flujo externo',
		'ENUM.CAN_IDENTIFIER.AUX0_Ret_Fl': 'AUX0 flujo retráctil',
		'ENUM.CAN_IDENTIFIER.AUX1_Ext_Fl': 'AUX1 flujo externo',
		'ENUM.CAN_IDENTIFIER.AUX1_Ret_Fl': 'AUX1 flujo de retracción',
		'ENUM.CAN_IDENTIFIER.AUX2_Ext_Fl': 'AUX2 flujo externo',
		'ENUM.CAN_IDENTIFIER.AUX2_Ret_Fl': 'AUX2 flujo retráctil',
		'ENUM.CAN_IDENTIFIER.AUX3_Ext_Fl': 'AUX3 flujo externo',
		'ENUM.CAN_IDENTIFIER.AUX3_Ret_Fl': 'AUX3 flujo retráctil',
		'ENUM.CAN_IDENTIFIER.AUX4_Ext_Fl': 'AUX4 flujo externo',
		'ENUM.CAN_IDENTIFIER.AUX4_Ret_Fl': 'AUX4 flujo retráctil',
		'ENUM.CAN_IDENTIFIER.Ag1avg': 'IO-Box: Ángulo 1 medio',
		'ENUM.CAN_IDENTIFIER.Ag1max': 'IO-Box: Ángulo 1 máx.',
		'ENUM.CAN_IDENTIFIER.Ag1min': 'IO-Box: Ángulo 1 min',
		'ENUM.CAN_IDENTIFIER.Ag2avg': 'IO-Box: Ángulo 2 medio',
		'ENUM.CAN_IDENTIFIER.Ag2max': ' IO-Box: Angle 2 max ',
		'ENUM.CAN_IDENTIFIER.Ag2min': ' IO-Box: Ángulo 2 min ',
		'ENUM.CAN_IDENTIFIER.Ag3avg': 'IO-Box: Ángulo 3 medio',
		'ENUM.CAN_IDENTIFIER.Ag3max': 'IO-Box: Ángulo 3 máx.',
		'ENUM.CAN_IDENTIFIER.Ag3min': 'IO-Box: Ángulo 3 min',
		'ENUM.CAN_IDENTIFIER.ApplAci': 'SyreN: Ácido aplicado',
		'ENUM.CAN_IDENTIFIER.ApplAdd': 'SyreN: Aditivos aplicados',
		'ENUM.CAN_IDENTIFIER.ApplSlu': 'SyreN: Lodos aplicados',
		'ENUM.CAN_IDENTIFIER.AxleWeight_1': 'Peso de Eje 1',
		'ENUM.CAN_IDENTIFIER.AxleWeight_2': 'Peso de Eje 2',
		'ENUM.CAN_IDENTIFIER.C1': ' IO-Box: Counter 1 ',
		'ENUM.CAN_IDENTIFIER.C2': 'IO-Box: Contador 2',
		'ENUM.CAN_IDENTIFIER.Chop_Act': 'Cuchilla',
		'ENUM.CAN_IDENTIFIER.Circ_1_Stat': ' Circ_1_Stat ',
		'ENUM.CAN_IDENTIFIER.Circ_2A_Stat': ' Circ_2A_Stat ',
		'ENUM.CAN_IDENTIFIER.Circ_2B_Stat': 'Circ_2B_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_3_Stat': ' Circ_3_Stat ',
		'ENUM.CAN_IDENTIFIER.Circ_4_Stat': ' Circ_4_Stat ',
		'ENUM.CAN_IDENTIFIER.ClutSlip': 'Patinaje del embrague',
		'ENUM.CAN_IDENTIFIER.Cutter_Guide': 'Guía de corte',
		'ENUM.CAN_IDENTIFIER.Cutter_GuideP': 'Guía de corte (P)',
		'ENUM.CAN_IDENTIFIER.Cutter_Pos': 'Posición del cortador',
		'ENUM.CAN_IDENTIFIER.Cutter_State': 'Cortador',
		'ENUM.CAN_IDENTIFIER.D1': ' IO-Box: Digital 1 ',
		'ENUM.CAN_IDENTIFIER.D2': ' IO-Box: Digital 2 ',
		'ENUM.CAN_IDENTIFIER.D3': ' IO-Box: Digital 3 ',
		'ENUM.CAN_IDENTIFIER.D4': ' IO-Box: Digital 4 ',
		'ENUM.CAN_IDENTIFIER.Driv_Lever': 'Nivel del conductor',
		'ENUM.CAN_IDENTIFIER.ENG_ABLev': 'Nivel de AdBlue',
		'ENUM.CAN_IDENTIFIER.ENG_FueLev': 'Nivel de combustible',
		'ENUM.CAN_IDENTIFIER.ENG_FueRat': 'Tasa de combustible',
		'ENUM.CAN_IDENTIFIER.ENG_Spe': 'RPM',
		'ENUM.CAN_IDENTIFIER.ENG_Tor': 'Torque',
		'ENUM.CAN_IDENTIFIER.FHitch_Pos': 'Posición del enganche delantero',
		'ENUM.CAN_IDENTIFIER.FPTO_Eng': 'Frente da TDF activa',
		'ENUM.CAN_IDENTIFIER.FPTO_Spe': 'Velocidad TDF delantera',
		'ENUM.CAN_IDENTIFIER.Field_Switch': 'Conmutar_campo',
		'ENUM.CAN_IDENTIFIER.Field_Switch2': 'Conmutar_campo2',
		'ENUM.CAN_IDENTIFIER.Front_Draft': 'Anteproyecto',
		'ENUM.CAN_IDENTIFIER.Front_NForce': 'Calado (nominal) delantero',
		'ENUM.CAN_IDENTIFIER.GB_Dir': 'Dirección (terrestre)',
		'ENUM.CAN_IDENTIFIER.GB_Speed': 'Velocidad en tierra',
		'ENUM.CAN_IDENTIFIER.GPS_Speed': 'Velocidad GPS',
		'ENUM.CAN_IDENTIFIER.Gear_Sel': 'Marcha seleccionada',
		'ENUM.CAN_IDENTIFIER.GrainCnv_Pos': 'Posición del transportador de grano',
		'ENUM.CAN_IDENTIFIER.GrainTnk_Lev': 'Nivel del depósito de grano',
		'ENUM.CAN_IDENTIFIER.HySt_Dir': 'HySt_Dir ',
		'ENUM.CAN_IDENTIFIER.HySt_Mod': ' HySt_Mod ',
		'ENUM.CAN_IDENTIFIER.Impl_Work': 'Aplicar el estado de trabajo',
		'ENUM.CAN_IDENTIFIER.JbSta': 'SyreN: Trabajo activo',
		'ENUM.CAN_IDENTIFIER.Mot_L_Spe': 'Velocidad del motor (izquierda)',
		'ENUM.CAN_IDENTIFIER.Mot_L_Tor': 'Par motor (izquierda)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Spe': 'Motor (right) speed',
		'ENUM.CAN_IDENTIFIER.Mot_R_Tor': 'Par motor (derecha)',
		'ENUM.CAN_IDENTIFIER.NO_XTR': 'Sin valor',
		'ENUM.CAN_IDENTIFIER.NUE_abs': 'SIREn: NUE absoluto',
		'ENUM.CAN_IDENTIFIER.NUE_rel': ' SyreN: NUE relativo',
		'ENUM.CAN_IDENTIFIER.PHSlu': 'SyreN: pH de los purines',
		'ENUM.CAN_IDENTIFIER.PTO_Switch': 'Interruptor_PTO',
		'ENUM.CAN_IDENTIFIER.PTO_Switch1': 'Interruptor_PTO1',
		'ENUM.CAN_IDENTIFIER.PTO_Switch2': 'TDF _Switch2',
		'ENUM.CAN_IDENTIFIER.PTO_Switch3': 'Interruptor_TDF3',
		'ENUM.CAN_IDENTIFIER.PrxSen': 'IO-Box: Sensor de proximidad',
		'ENUM.CAN_IDENTIFIER.RHitch_Pos': 'Posición del enganche trasero',
		'ENUM.CAN_IDENTIFIER.RPTO_Eng': 'TDF trasera activa',
		'ENUM.CAN_IDENTIFIER.RPTO_Spe': 'Velocidad de la TDF trasera',
		'ENUM.CAN_IDENTIFIER.Rear_Draft': 'Proyecto trasero',
		'ENUM.CAN_IDENTIFIER.Rear_NForce': 'Calado (nominal) trasero',
		'ENUM.CAN_IDENTIFIER.Roll': 'IO-Box: Índice de balanceo',
		'ENUM.CAN_IDENTIFIER.Sli': 'Patinaje',
		'ENUM.CAN_IDENTIFIER.Spe': 'Velocidad',
		'ENUM.CAN_IDENTIFIER.StrawChop_Pos': 'Posición de cortador de paja',
		'ENUM.CAN_IDENTIFIER.Thresh_Drum': 'Trilla',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A1': 'Presión de los neumáticos izquierdos A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A2': 'Presión de los neumáticos izquierdos A2',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A1': 'Tire pressure derechos A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A2': 'Tire pressure derechos A2',
		'ENUM.CAN_IDENTIFIER.UnlAuger_Act': 'UnlAuger_Act',
		'ENUM.CAN_IDENTIFIER.WB_Dir': 'Dirección (basada en la rueda)',
		'ENUM.CAN_IDENTIFIER.WB_Speed': 'Velocidad por rueda',
		'ENUM.CAN_IDENTIFIER.Xacc': 'IO-Box: Aceleración X',
		'ENUM.CAN_IDENTIFIER.Yacc': 'IO-Box: Aceleración Y',
		'ENUM.CAN_IDENTIFIER.Yaw': 'IO-Box: Guiño',
		'ENUM.CAN_IDENTIFIER.Yield_Act': 'Rendimiento real',
		'ENUM.CAN_IDENTIFIER.Yield_Mois': 'Humedad de rendimiento',
		'ENUM.CAN_IDENTIFIER.Zacc': 'IO-Box: Aceleración Z',
		'ENUM.COSTPER.h': 'h',
		'ENUM.COSTPER.ha': 'ha',
		'ENUM.COSTPER.km': 'km',
		'ENUM.COSTPER.l': 'l',
		'ENUM.CURRENCY.DOLLAR': '$',
		'ENUM.CURRENCY.EURO': '€',
		'ENUM.CURRENCY.GBP': '£',
		'ENUM.EMPLOYEEROLE.ADMIN': 'Administrador',
		'ENUM.EMPLOYEEROLE.CONSULTANT': 'Consultor',
		'ENUM.EMPLOYEEROLE.DISPONENT': 'Despachador',
		'ENUM.EMPLOYEEROLE.DRIVER': 'Conductor',
		'ENUM.EVENTTYPE.COMMENT': 'Mensaje',
		'ENUM.EVENTTYPE.CT': 'Contador',
		'ENUM.EVENTTYPE.CT_RS': 'Reinicio del contador',
		'ENUM.EVENTTYPE.CUSTOMER': 'Cliente',
		'ENUM.EVENTTYPE.EMPL_C_IMPL': 'Las parejas de empleados aplican',
		'ENUM.EVENTTYPE.EMPL_E_FIELD': 'El empleado entra en el campo',
		'ENUM.EVENTTYPE.EMPL_E_MACH': 'El empleado entra en el tractor',
		'ENUM.EVENTTYPE.EMPL_L_FIELD': 'El empleado abandona el campo',
		'ENUM.EVENTTYPE.EMPL_L_MACH': 'El empleado abandona el tractor',
		'ENUM.EVENTTYPE.EMPL_P_START': 'El empleado inicia la pausa',
		'ENUM.EVENTTYPE.EMPL_P_STOP': 'El empleado termina la pausa',
		'ENUM.EVENTTYPE.EMPL_UC_IMPL': 'Empleado desacopla implemento',
		'ENUM.EVENTTYPE.EMPL_W_START': 'El empleado empieza a trabajar',
		'ENUM.EVENTTYPE.EMPL_W_STOP': 'El empleado termina su trabajo',
		'ENUM.EVENTTYPE.GTO70': 'Depósito de grano lleno',
		'ENUM.EVENTTYPE.JOBINFO': 'Información laboral',
		'ENUM.EVENTTYPE.JOB_PAUSE': 'Pausa en el trabajo',
		'ENUM.EVENTTYPE.JOB_RESUME': 'Trabajo reanudado',
		'ENUM.EVENTTYPE.JOB_START': 'Trabajo comenzado',
		'ENUM.EVENTTYPE.JOB_STOP': 'Trabajo pausado',
		'ENUM.EVENTTYPE.L_IMPL': 'Implemento cargado',
		'ENUM.EVENTTYPE.REFUELING': 'Reabastecimiento de combustible',
		'ENUM.EVENTTYPE.SYREN_CUSTOMER': 'SyreN customer',
		'ENUM.EVENTTYPE.SYREN_FIELD': 'SyreN campo',
		'ENUM.EVENTTYPE.SYREN_SLURRY_TYPE': 'Tipo de estiércol SyreN',
		'ENUM.EVENTTYPE.T2_ON': 'Adapter online',
		'ENUM.EVENTTYPE.UL_IMPL': 'Implemento descargado',
		'ENUM.EVENTTYPE.WEATHER': 'Tiempo',
		'ENUM.EVENTTYPE.WEIGHING': 'Pesaje',
		'ENUM.EVENTTYPE.WEIGHING_TARA': 'Pesaje (tara)',
		'ENUM.ISO_TASKDATA_STATE.CRE': 'Creado',
		'ENUM.ISO_TASKDATA_STATE.ONM': 'En máquina',
		'ENUM.ISO_TASKDATA_STATE.RDY': 'Listo',
		'ENUM.JOBGENERATIONSTATE.ARC': 'Archivado',
		'ENUM.JOBGENERATIONSTATE.DEL': 'Borrado ',
		'ENUM.JOBGENERATIONSTATE.EDT': 'Editado',
		'ENUM.JOBGENERATIONSTATE.GEN': 'Generado',
		'ENUM.JOBGENERATIONSTATE.MER': 'Combinando',
		'ENUM.JOBGENERATIONSTATE.QUE': 'En fila',
		'ENUM.JOBGENERATIONSTATE.READY': 'OK',
		'ENUM.JOBGENERATIONSTATE.REGEN': 'Regenerando',
		'ENUM.JOBGENERATIONSTATE.SPLT': 'Dividiendo',
		'ENUM.JOBGENERATIONSTATE.UPD': 'Actualizando',
		'ENUM.LOCATIONTYPE.FARM': 'Campo',
		'ENUM.LOCATIONTYPE.FUEL': 'Estación de servicio',
		'ENUM.LOCATIONTYPE.OTHERS': 'Otro',
		'ENUM.LOCATIONTYPE.STABLE': 'Casco',
		'ENUM.LOCATIONTYPE.WEIGHING': 'Escala',
		'ENUM.MACHINETYPE.COMBINE': 'Cosechadora',
		'ENUM.MACHINETYPE.EXCAVATOR': 'Excavadora',
		'ENUM.MACHINETYPE.FORAGE_HARVESTER': 'Picadora de forraje',
		'ENUM.MACHINETYPE.MISC': 'Otros',
		'ENUM.MACHINETYPE.SELF_PROPELLED': 'Autopropulsado',
		'ENUM.MACHINETYPE.SYREN': 'Sirena',
		'ENUM.MACHINETYPE.TELEHANDLER': 'Cargadora telescópica',
		'ENUM.MACHINETYPE.TRACTOR': 'Tractor',
		'ENUM.MACHINETYPE.TRUCK': 'Camión',
		'ENUM.MACHINETYPE.WHEELLOADER': 'Cargadora sobre ruedas',
		'ENUM.MSGUNIT.-': '-',
		'ENUM.MSGUNIT.AXLES': 'Ejes',
		'ENUM.MSGUNIT.CUBIC_M': 'm³',
		'ENUM.MSGUNIT.DOLLAR': '$',
		'ENUM.MSGUNIT.EURO': '€',
		'ENUM.MSGUNIT.KG': 'kg',
		'ENUM.MSGUNIT.LITER': 'l',
		'ENUM.MSGUNIT.TONS': 't',
		'ENUM.MSGUNIT.h': 'h',
		'ENUM.MSGUNIT.ha': 'ha',
		'ENUM.MSGUNIT.km': 'km',
		'ENUM.ONLY_ON_STATE.A': 'Siempre',
		'ENUM.ONLY_ON_STATE.F': 'Campo',
		'ENUM.ONLY_ON_STATE.L': 'Ubicación',
		'ENUM.ONLY_ON_STATE.R': 'Ruta',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_1200': 'AgLeader InCommand 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_800': 'AgLeader InCommand 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INTEGRA': 'AgLeader Integra',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_VERSA': 'AgLeader Versa',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD': 'Amazone Amapad',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD_2': 'Amazone Amapad 2',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_3': 'Amazone Amatron 3',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_4': 'Amazone Amapad 4',
		'ENUM.TRACTOR_TERMINAL_TYPE.AN_L10I': 'Andeo L10i',
		'ENUM.TRACTOR_TERMINAL_TYPE.A_XY': 'A_XY',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_1200': 'Case AFS Pro 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_700': 'Case AFS Pro 700',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_1200': 'CCI 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_800': 'CCI 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_CEMIS_1200': 'Claas Cemis 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S10': 'Claas S10',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S7': 'Claas S7',
		'ENUM.TRACTOR_TERMINAL_TYPE.C_S2034': 'C_S2034',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_ONE': 'Fendt One',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_VARIOTERMINAL_10_4': 'Fendt Varioterminal 10.4',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_2630': 'John Deere 2630',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_GEN4': 'John Deere Gen4',
		'ENUM.TRACTOR_TERMINAL_TYPE.KV_TELLUS': 'Kverneland Tellus',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME': 'Müller Elektronik Basic',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_COMFORT': 'Müller Elektronik Comfort',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_1200': 'Müller Elektronik Touch 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_800': 'Müller Elektronik Touch 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.MF_DATATRONIC_5': 'MF Datatronic 5',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR12': 'Raven CR12',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR7': 'Raven CR7',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_VIPER4': 'Raven Viper4',
		'ENUM.TRACTOR_TERMINAL_TYPE.RH_SMART_COMMAND': 'Reichhardt Smart Command',
		'ENUM.TRACTOR_TERMINAL_TYPE.SDF_IMONITOR3': 'SDF iMonitor3',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X25': 'Topcon x25',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X30': 'Topcon x30',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X35': 'Topcon x35',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_XD': 'Topcon XD',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_1260': 'Trimble GFX 1260',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_750': 'Trimble GFX 750',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_TMX_2050': 'Trimble TMX 2050',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_1': 'Tipo 1 (escribe en el USB)',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_2': 'Tipo 2 (no escribe en el USB)',
		'ENUM.TRANSPORTUNIT.-': '-',
		'ENUM.TRANSPORTUNIT.AXLES': 'Ejes',
		'ENUM.TRANSPORTUNIT.BALE': 'Bala',
		'ENUM.TRANSPORTUNIT.CUBIC_M': 'm³',
		'ENUM.TRANSPORTUNIT.KG': 'kg ',
		'ENUM.TRANSPORTUNIT.LITER': 'l',
		'ENUM.TRANSPORTUNIT.TONS': 't',
		'ENUM.USERROLE.ADMIN': 'Administrador',
		'ENUM.USERROLE.ENTERPRISE': 'Empresa',
		'ENUM.USERROLE.SALES_FORCE_TECH': 'Tecnología de ventas',
		'ENUM.USERROLE.TRAN': 'Traducción',
		'ENUM.USERROLE.USER': 'Usuario',
		'ENUM.USERROLE.USER_EMPL': 'Usuario (empresa)',
		'ENUM.USERSTATE.ACTIVE': 'Activo',
		'ENUM.USERSTATE.DISABLED': 'Discapacitados',
		'ENUM.USERSTATE.NOT_VERIFIED': 'No verificado',
		'ENUM.WORKSTATE.DRIVING': 'Conducir',
		'ENUM.WORKSTATE.DRIVING_MISC': 'Espera durante conducción',
		'ENUM.WORKSTATE.MISC_FIELD': 'Parado en campo',
		'ENUM.WORKSTATE.MISC_FIELD_GTF': 'Depósito de grano lleno',
		'ENUM.WORKSTATE.MISC_ROAD': 'Parado en ruta',
		'ENUM.WORKSTATE.PAUSE': 'Pausa',
		'ENUM.WORKSTATE.PREPARATION': 'Preparación',
		'ENUM.WORKSTATE.ROAD': 'Ruta',
		'ENUM.WORKSTATE.THRESHING': 'Trilla',
		'ENUM.WORKSTATE.THRESHING_U': 'Descargando durante la trilla',
		'ENUM.WORKSTATE.THRESHING_W_SC': 'Trilla con picadora de paja',
		'ENUM.WORKSTATE.THRESHING_W_SC_U': 'Descarga durante la trilla con picadora de paja',
		'ENUM.WORKSTATE.TRANSPORT_LOADED': 'Cargado',
		'ENUM.WORKSTATE.TRANSPORT_LOADED_MISC': 'Espera durante carga',
		'ENUM.WORKSTATE.TRANSPORT_LOADING': 'Cargando',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED': 'Descargado',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED_MISC': 'Espera durante descarga',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING': 'Descargando',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING_DRIV': 'Descargando en conducción',
		'ENUM.WORKSTATE.TURNING': 'Girando',
		'ENUM.WORKSTATE.UNDEFINED': 'Sin definir',
		'ENUM.WORKSTATE.WORKING': 'Trabajando',
		'ENUM.WORKSTATE.WORKING_MISC': 'Espera durante trabajo',
		'ERROR.NO_GPS_DATA': 'No hay datos GPS para la máquina seleccionada.',
		'ERROR_MESSAGE': 'Error en el mensaje',
		'EVENTS': 'Eventos',
		'EVENTS.FIELD': 'Eventos sobre el campo',
		'EVENTS.NO': 'Sin eventos',
		'EXA_ADAPTERS': 'Módulo',
		'EXA_ADAPTERS.AR_ACTIVATE': 'Activar módulo en Agrirouter',
		'EXA_ADAPTERS.AR_DEACTIVATE': 'Borrar módulo en Agrirouter',
		'EXA_ADAPTERS.AR_LINK_SUCCESS': 'Módulo activado en Agrirouter',
		'EXA_ADAPTERS.AR_UNLINK_SUCCESS': 'Módulo eliminado de Agrirouter',
		'EXCEPTION.1': 'Error interno',
		'EXCEPTION.100': 'Enumeración no válida',
		'EXCEPTION.1000': 'El nombre de usuario está vacío',
		'EXCEPTION.10000': 'El nombre del archivo está vacío',
		'EXCEPTION.10001': 'Los datos están vacíos',
		'EXCEPTION.10002': 'Formato tipo inválido',
		'EXCEPTION.10003': 'DataRequestType inválido',
		'EXCEPTION.10004': 'Datos sin procesar',
		'EXCEPTION.1001': 'La longitud del nombre de usuario es inferior a la mínima',
		'EXCEPTION.1002': 'El nombre de usuario ya está ocupado',
		'EXCEPTION.1003': 'Dirección de correo electrónico no válida',
		'EXCEPTION.1004': 'La dirección de correo electrónico ya está ocupada',
		'EXCEPTION.1005': 'La longitud de la contraseña es inferior a la mínima',
		'EXCEPTION.1007': 'Código de verificación es inválido',
		'EXCEPTION.1008': 'Nombre de usuario (o dirección de correo electrónico) no válido',
		'EXCEPTION.101': 'Rol de empleado no válido',
		'EXCEPTION.1011': 'El usuario no existe',
		'EXCEPTION.1012': 'Usuario eliminado',
		'EXCEPTION.1013': 'Usuario inactivo',
		'EXCEPTION.1014': 'Usuario bloqueado',
		'EXCEPTION.1015': 'Usuario no activado',
		'EXCEPTION.1016': 'El usuario es una cuenta de empresa',
		'EXCEPTION.102': 'Moneda no válida',
		'EXCEPTION.1020': 'El usuario ya existe',
		'EXCEPTION.1021': 'Dirección de correo electrónico ya ocupada',
		'EXCEPTION.1022': 'La dirección de correo electrónico no ha cambiado',
		'EXCEPTION.1023': 'La contraseña actual no coincide',
		'EXCEPTION.1024': 'El nombre de usuario ya está ocupado',
		'EXCEPTION.1025': 'Usuario y código no coinciden',
		'EXCEPTION.1026': 'Nombre de usuario (o dirección de correo electrónico) no válido',
		'EXCEPTION.1027': 'Usuario ya activado',
		'EXCEPTION.1028': 'Prohibido para cuentas de empleados creadas para una empresa',
		'EXCEPTION.103': 'Unidad de transporte no válida',
		'EXCEPTION.104': 'Tipo de ubicación no válida',
		'EXCEPTION.105': 'Unidad de coste no válida',
		'EXCEPTION.106': 'Unidad inválida',
		'EXCEPTION.107': 'Tipo de máquina no válida',
		'EXCEPTION.108': 'Estado del empleado no válido',
		'EXCEPTION.11000': 'Tipo inválido',
		'EXCEPTION.12000': 'Tipo inválido',
		'EXCEPTION.12002': 'La serie está vacía',
		'EXCEPTION.12003': 'Estado de trabajo no válido',
		'EXCEPTION.12004': 'Estado del trabajo no válido',
		'EXCEPTION.12006': 'Sin configuración T2',
		'EXCEPTION.12007': 'MAC está vacío',
		'EXCEPTION.12008': 'MAC inválido',
		'EXCEPTION.12009': 'El módulo ya existe',
		'EXCEPTION.12010': 'Tipo de módulo no válido',
		'EXCEPTION.15000': 'La hora de inicio está vacía o en el futuro',
		'EXCEPTION.15001': 'El tiempo de parada está vacío o en el futuro',
		'EXCEPTION.15002': 'La hora de parada es igual o anterior a la hora de inicio',
		'EXCEPTION.15003': 'No se puede generar el paquete SILO - No hay datos brutos',
		'EXCEPTION.15004': 'Datos brutos demasiado antiguos',
		'EXCEPTION.16000': 'El nombre está vacío',
		'EXCEPTION.16001': 'El cliente asignado no existe',
		'EXCEPTION.16002': 'La lista de marcadores está vacía',
		'EXCEPTION.16003': 'La lista de marcadores debe contener al menos tres marcadores',
		'EXCEPTION.16004': 'El área está vacía',
		'EXCEPTION.16005': 'Tipo de marcador no válido',
		'EXCEPTION.16006': 'El campo no está contenido en el trabajo',
		'EXCEPTION.16007': 'El tamaño de la cuadrícula es superior a la mitad de la altura y la anchura del campo',
		'EXCEPTION.16008': 'No hay datos para interpolar',
		'EXCEPTION.16009': 'Todos los datos contienen el mismo valor',
		'EXCEPTION.17000': 'El nombre está vacío',
		'EXCEPTION.17001': 'La persona de contacto está vacía',
		'EXCEPTION.17002': 'Teléfono no válido',
		'EXCEPTION.17003': 'La dirección de correo electrónico está vacía',
		'EXCEPTION.17004': 'Dirección de correo electrónico no válida',
		'EXCEPTION.17005': 'La dirección está vacía',
		'EXCEPTION.17006': 'El código postal está vacío',
		'EXCEPTION.17007': 'La ciudad está vacía',
		'EXCEPTION.17008': 'Color no válido ((AA)RRGGBB)',
		'EXCEPTION.18000': 'Tipo inválido',
		'EXCEPTION.19001': 'Tipo inválido',
		'EXCEPTION.19002': 'MAC está vacío',
		'EXCEPTION.19003': 'MAC inválido',
		'EXCEPTION.19004': 'La potencia es inferior a cero',
		'EXCEPTION.19007': 'El empleado está vacío',
		'EXCEPTION.19008': 'Beacon no es un faro',
		'EXCEPTION.19009': 'El beacon no es una beacon de conductor',
		'EXCEPTION.2': 'Entrada duplicada',
		'EXCEPTION.200': 'Error al analizar el tipo de objeto Json',
		'EXCEPTION.2000': 'Error en la creación del código de verificación',
		'EXCEPTION.20000': 'Cantidad de datos brutos demasiado baja',
		'EXCEPTION.20001': 'Error en la creación del archivo',
		'EXCEPTION.20002': 'Error en la carga del archivo',
		'EXCEPTION.2001': 'El código de verificación no existe',
		'EXCEPTION.2002': 'Código de verificación inválido',
		'EXCEPTION.201': 'Error al escribir Object Type en Json',
		'EXCEPTION.21000': 'El nombre de la empresa está vacío',
		'EXCEPTION.21001': 'Nombre de empresa ya ocupado',
		'EXCEPTION.21002': 'La longitud del nombre de la empresa es inferior a la mínima',
		'EXCEPTION.21003': 'La dirección de correo electrónico de la empresa no es válida',
		'EXCEPTION.21004': 'El código de acceso ya existe',
		'EXCEPTION.21005': 'Se elimina la empresa',
		'EXCEPTION.21006': 'La empresa está desactivada',
		'EXCEPTION.21007': 'La empresa está bloqueada',
		'EXCEPTION.21008': 'Tipo de empresa no válido',
		'EXCEPTION.22000': 'No hay trabajos que añadir',
		'EXCEPTION.22001': 'No ha cambiado ningún trabajo',
		'EXCEPTION.23000': 'Empresa no incorporada',
		'EXCEPTION.23001': 'Empresa ya incorporada',
		'EXCEPTION.23002': 'Módulo no integrado',
		'EXCEPTION.23003': 'Módulo ya incorporado',
		'EXCEPTION.23004': 'No se ha podido integrar el módulo',
		'EXCEPTION.23005': 'No se ha podido reinstalar el módulo',
		'EXCEPTION.23006': 'No se ha podido instalar el módulo',
		'EXCEPTION.23007': 'Fallo en la publicación de capacidades vCU',
		'EXCEPTION.23008': 'Fallo en la publicación de datos vCU',
		'EXCEPTION.23009': 'Error al publicar la descripción del dispositivo vCU',
		'EXCEPTION.23010': 'Publicación de capacidades empresariales fallidas',
		'EXCEPTION.23011': '¡Error de certificado Agrirouter! ¿Ha renovado la conexión Agrirouter?',
		'EXCEPTION.24000': 'El nombre de la empresa está vacío',
		'EXCEPTION.24001': 'Nombre de empresa ya ocupado',
		'EXCEPTION.24002': 'La longitud del nombre de la empresa es inferior a la mínima',
		'EXCEPTION.24003': 'La dirección de correo electrónico de la empresa no es válida',
		'EXCEPTION.24004': 'El código de acceso ya existe',
		'EXCEPTION.24005': 'Se elimina la empresa',
		'EXCEPTION.24006': 'La empresa está desactivada',
		'EXCEPTION.24007': 'La empresa está bloqueada',
		'EXCEPTION.25000': 'Función no disponible para el interlocutor seleccionado',
		'EXCEPTION.25001': 'Error de sincronización de campos',
		'EXCEPTION.25002': 'Fallo en la sincronización de máquinas',
		'EXCEPTION.25003': 'Error en la sincronización de implementos',
		'EXCEPTION.25004': 'Falló la máquina de obtención',
		'EXCEPTION.25005': 'Error al crear la máquina',
		'EXCEPTION.25006': 'Falló la actualización de la máquina',
		'EXCEPTION.25007': 'Error al borrar la máquina',
		'EXCEPTION.25008': 'Error de implementación',
		'EXCEPTION.25009': 'Error en la creación del implemento',
		'EXCEPTION.25010': 'Error en la actualización del implemento',
		'EXCEPTION.25011': 'Error al borrar el implemento',
		'EXCEPTION.26000': 'Error en la creación del archivo PDF',
		'EXCEPTION.26001': 'El trabajo seleccionado no está habilitado para SyreN',
		'EXCEPTION.27000': 'La máquina no admite archivos TaskData',
		'EXCEPTION.27001': 'Error en la creación del archivo TaskData',
		'EXCEPTION.27002': 'Error en la carga del archivo TaskData',
		'EXCEPTION.27003': 'La máquina no tiene ningún módulo asignado',
		'EXCEPTION.27004': 'El nombre está vacío',
		'EXCEPTION.27005': 'La fecha prevista está vacía',
		'EXCEPTION.27006': 'La fecha prevista no es futura',
		'EXCEPTION.27007': 'Estado vacío',
		'EXCEPTION.27008': 'El archivo está vacío',
		'EXCEPTION.27009': 'El nombre del archivo está vacío',
		'EXCEPTION.27010': 'La fecha está vacía',
		'EXCEPTION.27011': 'La fecha no es futura',
		'EXCEPTION.27012': 'El tamaño es inferior a uno',
		'EXCEPTION.27013': 'Operación TaskData no disponible en el estado actual',
		'EXCEPTION.27014': 'Nombre de archivo ya ocupado',
		'EXCEPTION.27015': 'No hay tareas pendientes',
		'EXCEPTION.27016': 'Sólo se permite un archivo TaskData no descargado',
		'EXCEPTION.28001': 'Tipo de archivo no compatible',
		'EXCEPTION.29000': 'Actualización no permitida (ya procesada)',
		'EXCEPTION.29001': 'No se proporciona ninguna máquina o implemento',
		'EXCEPTION.29002': 'Sólo se permite máquina o implemento',
		'EXCEPTION.29003': 'El valor base debe ser mayor que cero',
		'EXCEPTION.29004': 'El valor de la advertencia debe ser superior a cero',
		'EXCEPTION.29005': 'El valor debido debe ser superior a cero',
		'EXCEPTION.29006': 'El intervalo de vencimiento debe ser mayor que el intervalo de aviso',
		'EXCEPTION.3000': 'La información de inicio de sesión no es válida',
		'EXCEPTION.3001': 'Cuenta bloqueada',
		'EXCEPTION.3002': 'La cuenta no está activada',
		'EXCEPTION.3003': 'Sesión expirada - Por favor, inicie sesión de nuevo',
		'EXCEPTION.3004': 'Otro usuario conectado con la misma cuenta',
		'EXCEPTION.31000': 'Aplicación no compatible',
		'EXCEPTION.4000': 'Fabricante está vacío',
		'EXCEPTION.4001': 'El modelo está vacío',
		'EXCEPTION.4002': 'Año tiene que ser greated que 1950 y no en el futuro',
		'EXCEPTION.4003': 'Costo inferior o igual a cero',
		'EXCEPTION.4004': 'Las horas de funcionamiento son inferiores a cero',
		'EXCEPTION.4005': 'El kilometraje es inferior a cero',
		'EXCEPTION.4007': 'El ancho de trabajo es inferior a cero',
		'EXCEPTION.4008': 'Color no válido ((AA)RRGGBB)',
		'EXCEPTION.4009': 'XtrCanValuesConfig inválido',
		'EXCEPTION.401': 'Sin autorización',
		'EXCEPTION.4010': 'Demasiados valores de configuración',
		'EXCEPTION.4011': 'Configuración dinámica inválida',
		'EXCEPTION.4012': 'El tipo de máquina no es un tractor',
		'EXCEPTION.4013': 'Se toma el número máximo de licencias',
		'EXCEPTION.4014': 'La fecha es futura',
		'EXCEPTION.4015': 'Anulación de velocidad inválida',
		'EXCEPTION.403': 'Prohibido',
		'EXCEPTION.450': 'Error de comando',
		'EXCEPTION.451': 'No se requiere licencia',
		'EXCEPTION.452': 'Parámetro de filtro no válido',
		'EXCEPTION.5000': 'Fabricante está vacío',
		'EXCEPTION.5001': 'El modelo está vacío',
		'EXCEPTION.5002': 'Año tiene que ser greated que 1950 y no en el futuro',
		'EXCEPTION.5003': 'Tipo1 está vacío',
		'EXCEPTION.5004': 'Tipo2 no válido',
		'EXCEPTION.5005': 'El costo es inferior o igual a cero',
		'EXCEPTION.5006': 'El ancho de trabajo es inferior a cero',
		'EXCEPTION.5007': 'El valor de transporte es inferior a cero',
		'EXCEPTION.5008': 'Unidad de transporte no válida',
		'EXCEPTION.5009': 'Tipo3 no válido',
		'EXCEPTION.5010': 'Combinación de tipos no válida',
		'EXCEPTION.5011': 'Identificador contable no válido',
		'EXCEPTION.6000': 'Tipo inválido',
		'EXCEPTION.6001': 'El radio está vacío o por debajo de cero',
		'EXCEPTION.6002': 'El nombre está vacío',
		'EXCEPTION.6003': 'La lista de marcadores está vacía',
		'EXCEPTION.6004': 'La lista de marcadores debe contener al menos tres marcadores',
		'EXCEPTION.6005': 'Tipo de marcador no válido',
		'EXCEPTION.6006': 'Tipo de pesaje no válido',
		'EXCEPTION.700': 'VarName no válido',
		'EXCEPTION.7001': 'La cuenta no existe',
		'EXCEPTION.7002': 'Cuenta bloqueada',
		'EXCEPTION.701': 'Fórmula inválida',
		'EXCEPTION.702': 'CANIdName no válido',
		'EXCEPTION.703': 'Condición inválida',
		'EXCEPTION.704': 'VarName no válido',
		'EXCEPTION.705': 'Parámetro de estado de trabajo no válido',
		'EXCEPTION.706': 'Estado de trabajo no válido para el tipo de implemento',
		'EXCEPTION.707': 'Error en la creación del archivo',
		'EXCEPTION.800': 'ConfigValue nombre no válido',
		'EXCEPTION.8000': 'El empleador está vacío',
		'EXCEPTION.8001': 'El empleado está vacío',
		'EXCEPTION.8002': 'Empleado no encontrado para el empresario',
		'EXCEPTION.8003': 'Coste inferior a cero',
		'EXCEPTION.8004': 'Número máximo de licencias de usuario tomadas',
		'EXCEPTION.8005': 'No es su empleador',
		'EXCEPTION.8006': 'El empleado ya existe',
		'EXCEPTION.8007': 'El token de acceso está vacío',
		'EXCEPTION.8008': 'Token de acceso inválido',
		'EXCEPTION.8009': 'En una empresa debe existir al menos un administrador',
		'EXCEPTION.8010': 'El usuario sólo puede conectarse a la empresa que lo creó',
		'EXCEPTION.900': 'No existe',
		'EXCEPTION.9000': 'La hora de inicio está vacía o en el futuro',
		'EXCEPTION.9001': 'El tiempo de parada está vacío o en el futuro',
		'EXCEPTION.9002': 'La hora de parada es igual o inferior a la hora de inicio',
		'EXCEPTION.9003': 'El conductor no es empleado del propietario del trabajo',
		'EXCEPTION.9004': 'El implemento no pertenece al propietario del trabajo',
		'EXCEPTION.9005': 'Tipo1 no válido',
		'EXCEPTION.9006': 'Tipo2 no válido',
		'EXCEPTION.9007': 'Tipo3 no válido',
		'EXCEPTION.9008': 'No se puede generar el trabajo - no hay datos brutos',
		'EXCEPTION.9009': 'El propietario de la máquina no coincide con el propietario del implemento',
		'EXCEPTION.901': 'Ya existe',
		'EXCEPTION.9010': 'El puesto ya existe',
		'EXCEPTION.9012': 'El trabajo no está listo',
		'EXCEPTION.9013': 'El trabajo está marcado para ser eliminado',
		'EXCEPTION.9014': 'Trabajo archivado - No hay lugares de trabajo disponibles',
		'EXCEPTION.9015': 'Datos brutos demasiado antiguos',
		'EXCEPTION.9016': 'Al menos un trabajo forma parte de una tarea',
		'EXCEPTION.9017': 'Los trabajos no coinciden (máquina, controlador e implemento deben coincidir)',
		'EXCEPTION.9018': 'La diferencia entre trabajos es demasiado grande',
		'EXCEPTION.9019': 'Al menos un trabajo forma parte de una tarea',
		'EXCEPTION.902': 'El propietario no existe',
		'EXCEPTION.9020': 'Sin tiempos de división',
		'EXCEPTION.9021': 'El tiempo de división no es mayor que el de inicio ni menor que el de parada',
		'EXCEPTION.9022': 'No hay identificadores de trabajo para la fusión',
		'EXCEPTION.9023': 'Se requieren al menos dos trabajos',
		'EXCEPTION.9024': 'La densidad de puntos tiene que ser mayor que cero y menor o igual que uno',
		'EXCEPTION.903': 'El objeto con el ID no existe',
		'EXCEPTION.904': 'Latitud fuera de rango',
		'EXCEPTION.905': 'Longitud fuera de rango',
		'EXCEPTION.906': 'El propietario no coincide',
		'EXCEPTION.907': 'El parámetro está vacío',
		'EXCEPTION.99': 'Parámetro no válido',
		'EXPORT': 'Exportar',
		'EXPORT.FILTERED_JOBS': 'Exportar todas las tareas filtradas',
		'EXPORT.JOB_DETAILS': 'Exportar detalles del trabajo',
		'EXPORT.OPERATIONS.CUSTOMER.PERIOD': 'Exportar todos los datos del cliente en el periodo seleccionado',
		'EXPORT.OPERATIONS.FIELDS.PERIOD': 'Exportar todas las operaciones sobre campos en el periodo seleccionado',
		'EXPORT.OPERATIONS.LOCATIONS.PERIOD': 'Exportar todas las operaciones en ubicaciones en el periodo seleccionado',
		'EXPORT.POINTS': 'Puntos de referencia',
		'EXPORT.POLYGONS': 'Polígonos',
		'EXPORT.RAW_DATA_AS_SILO': 'Exportar los datos brutos del trabajo como fichero SILO',
		'EXPORT.SELECTED': 'Exportación seleccionada',
		'EXPORT.SELECT_DATA': 'Seleccione los datos que se incluirán en el informe en PDF',
		'EXPORT.SELECT_PERIOD': 'Seleccione el periodo a exportar',
		"FERTILIZER": "Fertilizante",
		'FIELD': 'Campo',
		'FIELD.ADD': 'Añadir campo',
		'FIELD.ADD.SUCCESS': 'Campo añadido correctamente',
		'FIELD.DEACTIVATE.QUESTION': '¿Realmente quiere desactivar el campo?',
		'FIELD.DEACTIVATE.SUCCESS': 'Campo desactivado correctamente',
		'FIELD.DELETE.QUESTION': '¿Realmente quieres borrar el campo?',
		'FIELD.DELETE.SUCCESS': 'Campo eliminado correctamente',
		'FIELD.DETAILS': 'Detalles del campo',
		'FIELD.DRAW.START': 'Dibuje ahora los límites de los campos en el mapa',
		'FIELD.EDIT.SUCCESS': 'Campo editado correctamente',
		'FIELD.INTERPOLATE': 'Interpolar',
		'FIELD.INTERPOLATED_VALUES': 'Valores interpolados',
		'FIELD.INTERPOLATION': 'Interpolación',
		'FIELD.INTERPOLATION_SETTINGS': 'Ajustes de interpolación',
		'FIELD.INTERPOLATION_SETTINGS.FINE': 'Fino',
		'FIELD.INTERPOLATION_SETTINGS.FINE+': 'Muy fino',
		'FIELD.INTERPOLATION_SETTINGS.ROUGH': 'Áspero',
		'FIELD.INTERPOLATION_SETTINGS.STANDARD': 'Estándar',
		'FIELD.NUMBER': 'Número de campo',
		'FIELD.PROCESSED': 'Campo procesado',
		'FIELDS': 'Campos',
		'FIELDS.ALL': 'Todos los campos',
		'FIELDS.DEACTIVATE.FAILURE': 'Some of the fields could not be deactivated.',
		'FIELDS.DEACTIVATE.QUESTION': '¿Realmente quiere desactivar los campos?',
		'FIELDS.DEACTIVATE.SUCCESS': 'Campos desactivados correctamente',
		'FIELDS.DELETE.FAILURE': 'No se han podido eliminar algunos campos.',
		'FIELDS.DELETE.QUESTION': '¿Realmente desea eliminar los campos seleccionados?',
		'FIELDS.DELETE.SUCCESS': 'Los campos se han eliminado correctamente',
		'FIELDS.EDIT': 'Editar campos',
		'FIELDS.IMPORT': 'Importar campos',
		'FIELDS.IMPORT.ASSIGN_CUSTOMER.QUESTION': '¿Desea asignar un cliente a los campos seleccionados?',
		'FIELDS.IMPORT.SHAPE': 'Seleccione un archivo SHAPE para importar.',
		'FIELDS.IMPORT.SUCCESS': 'Campos importados correctamente',
		'FIELDS.MANAGEMENT': 'Administración de campos',
		'FIELDS.NO': 'Sin campos',
		'FIELDS.NOT_SELECTED': 'No hay campos seleccionados',
		'FIELDS.REACTIVATE.FAILURE': 'Algunos de los campos no pudieron reactivarse.',
		'FIELDS.REACTIVATE.QUESTION': '¿Realmente desea reactivar los campos seleccionados?',
		'FIELDS.REACTIVATE.SUCCESS': 'Campos reactivados correctamente',
		'FIELDS.SELECT': 'Seleccionar campos',
		'FIELDS.SELECTED': 'Campos seleccionados',
		'FILE': 'Archivo',
		'FILE.GENERATING': 'El archivo se está generando y añadiendo al gestor de archivos',
		'FILE.GENERATING.READY': 'Un nuevo archivo está listo para descargar',
		'FILE.MANAGER': 'Gestor de archivos',
		'FILE.NO_FILES': 'No hay archivos existentes',
		'FILE.UPLOAD': 'Cargar archivo',
		'FILE_TRANSFER': 'Transferencia de archivos',
		'FILE_TRANSFER.ADD': 'Añadir archivo',
		'FILE_TRANSFER.ADD.SUCCESS': 'Archivo añadido con éxito',
		'FILE_TRANSFER.CREATE': 'Añadir archivo',
		'FILE_TRANSFER.DELETE.QUESTION': '¿Realmente quieres borrar el archivo?',
		'FILE_TRANSFER.DELETE.SUCCESS': 'Archivo eliminado con éxito',
		'FILE_TRANSFER.FINISHED_TASKS': 'Tareas preparadas',
		'FILE_TRANSFER.NO': 'Sin archivos',
		'FILE_TRANSFER.QUEUED_TASKS': 'Tareas en cola',
		'FILTER': 'Filtro',
		'FIRMWARE_VERSION': 'Versión del firmware',
		'FIRSTNAME': 'Nombre',
		'FORMS.FILE_TOO_LARGE': 'El archivo es demasiado grande',
		'FORMS.NO_PASSWORD_MATCH': 'Las contraseñas no coinciden',
		'FORMS.REQUIRED': 'Requerido',
    'FORMS.INVALID_EMAIL': 'Correo no válido',
		'FORMULA': 'Fórmula',
		'FUEL': 'Combustible',
		'FUEL.CONSUMPTION': 'Consumo de combustible',
		'FUEL.CONSUMPTION.AREA': 'Consumo de combustible por superficie',
		'FUEL.CONSUMPTION.AVERAGE': 'Consumo medio de combustible',
		'FUEL.CONSUMPTION.OVERALL': 'Consumo total de combustible',
		'FUEL.CONSUMPTION.TOTAL': 'Consumo total de combustible',
		'FUEL.COST': 'Coste del combustible',
		'FUEL.LEVEL': 'Nivel de combustible',
		'FUEL.PRICE_PER_LITER': 'Precio del combustible por litro',
		'FUEL.WARNING': '¡Nivel de combustible bajo!',
		'GENERAL_INSPECTION': 'Inspección general',
		'GEOMETRIES.UPDATE': 'Actualizar campos y ubicaciones',
		'GEOMETRY.ADD.REGENERATION_NEEDED': 'Todos los datos subyacentes deben actualizarse para asignarlos correctamente después de añadir una nueva geometría. ¿Desea actualizar los datos ahora?',
		'GEOMETRY.CLICK_TO_SAVE': 'Para guardar, haga clic en la mapa.',
		'GPS': 'GPS',
		'GPS.GPS': 'GPS interno',
		'GPS.LP': 'Última posición conocida',
		'GPS.RTK': 'RTK',
		'GPS.RTK_H': 'RTK (alta precisión)',
		'GPS.STATUS': 'Estado del GPS',
		'GPS_HITCH_DISTANCE.IMPLEMENT.INFO': 'For recording the machine track correctly you need to input the distance between the hitch (A) and the point of application of the implement (B). The distance is measured in cm.',
		'GPS_HITCH_DISTANCE.MACHINE.INFO': 'For recording the machine track correctly you need to input the distance between the GPS receiver (A) and the hitch of the machine (B). The distance is measured in cm.',
		'GPS_TO_HITCH_DISTANCE': 'Distancia del GPS al enganche',
		'HARDWARE': 'Hardware',
		'HARDWARE.SETUP.PRINT_STICKER': 'Imprimir etiqueta de hardware',
		'HARDWARE.SETUP.PRINT_STICKER_PACKAGING': 'Imprimir etiqueta de paquete',
		'HARDWARE.SETUP.RESET_DEVICE': 'Reiniciar dispositivo',
		'HARDWARE.SETUP.SET_SERIAL': 'Configurar serie',
		'HEADLAND.PASSES': 'Headland passes',
		'HELPER_MODEL_TEXT': 'Modelo según la entrada',
		'HINT_MARKERS.SHOW': 'Mostrar marcadores de sugerencias',
		'HITCH_TO_APPLICATION_DISTANCE': 'Distancia del enganche a la aplicación',
		'HITCH:INVALID': 'Introduzca un valor numérico válido (con un máximo de un decimal; se permiten valores negativos o positivos).',
		'HOME': 'Bienvenido',
		'HOME.CONTACTREPLY1': 'Entonces no dude en llamarnos al',
		'HOME.CONTACTREPLY2': 'o envíenos un correo electrónico a',
		'HOME.INTRODUCTORY_VIDEOS': 'Vídeos introductorios',
		'HOME.NEWSINFO1': 'Encontrará todas las novedades e información interesante sobre gestión de flotas y seguimiento de máquinas en nuestra sección',
		'HOME.NEWSINFO2': 'o en nuestro',
		'HOME.PROFILEEXPLANATION': 'En \"Mi perfil\" puede modificar sus datos personales, su correo electrónico y su contraseña.',
		'HOME.QUESTIONSYSTEM': '¿Tiene alguna pregunta sobre nuestro sistema?',
		'HOME.TITLE': 'Bienvenido',
		'HOME.WELCOMEAREA': '¡Bienvenido a tu zona!',
		'IDLE': 'Ocioso',
		'IGNORE': 'Ignore',
		'IMPLEMENT': 'Implemento',
		'IMPLEMENT.ADD': 'Añadir implemento',
		'IMPLEMENT.ADD.SUCCESS': 'Aplicación añadida con éxito',
		'IMPLEMENT.CLASS': 'Tipo de implemento',
		'IMPLEMENT.DELETE.QUESTION': '¿De verdad quieres eliminar el implemento?',
		'IMPLEMENT.DELETE.SUCCESS': 'Implemento eliminado con éxito',
		'IMPLEMENT.DETAILS': 'Detalles del implemento',
		'IMPLEMENT.EDIT': 'Editar implemento',
		'IMPLEMENT.EDIT.SUCCESS': 'Implementar con éxito editado',
		'IMPLEMENT.FIXED': 'Implemento fijo',
		'IMPLEMENT.NO': 'Sin implemento',
		'IMPLEMENT.PROCESS.0': 'Sin implemento',
		'IMPLEMENT.PROCESS.1': 'Empacado de fardos',
		'IMPLEMENT.PROCESS.10': 'Rastra',
		'IMPLEMENT.PROCESS.11': 'Siembra',
		'IMPLEMENT.PROCESS.12': 'Plantación',
		'IMPLEMENT.PROCESS.13': 'Fertilización',
		'IMPLEMENT.PROCESS.14': 'Pulverización',
		'IMPLEMENT.PROCESS.15': 'Riego',
		'IMPLEMENT.PROCESS.16': 'Corte',
		'IMPLEMENT.PROCESS.17': 'Torneado de hierba',
		'IMPLEMENT.PROCESS.18': 'Transporte',
		'IMPLEMENT.PROCESS.19': 'Barrida',
		'IMPLEMENT.PROCESS.2': 'Empacado de fardos cuadrados',
		'IMPLEMENT.PROCESS.20': 'Quitado de nieve',
		'IMPLEMENT.PROCESS.21': 'Esparcimiento de  sal',
		'IMPLEMENT.PROCESS.22': 'Azada',
		'IMPLEMENT.PROCESS.23': 'Fertilización',
		'IMPLEMENT.PROCESS.24': 'Bombeo de purines',
		'IMPLEMENT.PROCESS.25': 'Mezclado de purines',
		'IMPLEMENT.PROCESS.26': 'Siembra de papas',
		'IMPLEMENT.PROCESS.27': 'Cosecha de papas',
		'IMPLEMENT.PROCESS.28': 'Separación',
		'IMPLEMENT.PROCESS.29': 'Formación de crestas',
		'IMPLEMENT.PROCESS.3': 'Empacado de fardos',
		'IMPLEMENT.PROCESS.30': 'Cobertura de suelo',
		'IMPLEMENT.PROCESS.31': 'Hilerado',
		'IMPLEMENT.PROCESS.32': 'Desgarre',
		'IMPLEMENT.PROCESS.33': 'Desgarre',
		'IMPLEMENT.PROCESS.34': 'Picado',
		'IMPLEMENT.PROCESS.35': 'Barrida',
		'IMPLEMENT.PROCESS.36': 'Soplado de nieve',
		'IMPLEMENT.PROCESS.37': 'Trasladado contenedores de estiércol líquido',
		'IMPLEMENT.PROCESS.38': 'Formación de camas de siembra',
		'IMPLEMENT.PROCESS.39': 'Alimentación de ganado',
		'IMPLEMENT.PROCESS.4': 'Envoltura de pacas',
		'IMPLEMENT.PROCESS.40': 'Movimiento de madera',
		'IMPLEMENT.PROCESS.41': 'Madera de sierra',
		'IMPLEMENT.PROCESS.42': 'Separación de madera',
		'IMPLEMENT.PROCESS.43': 'Molienda de tocones',
		'IMPLEMENT.PROCESS.44': 'Cargado material a granel',
		'IMPLEMENT.PROCESS.45': 'Cargado de pallets',
		'IMPLEMENT.PROCESS.46': 'Cargado de balas',
		'IMPLEMENT.PROCESS.47': 'Conversión del triturado',
		'IMPLEMENT.PROCESS.48': 'Empuje',
		'IMPLEMENT.PROCESS.49': 'Peso delantero/trasero',
		'IMPLEMENT.PROCESS.5': 'Arado',
		'IMPLEMENT.PROCESS.50': 'Trilla',
		'IMPLEMENT.PROCESS.51': 'Picado',
		'IMPLEMENT.PROCESS.52': 'Empaque de fardos de alta presión',
		'IMPLEMENT.PROCESS.53': 'Deshoje',
		'IMPLEMENT.PROCESS.54': 'Cepillado',
		'IMPLEMENT.PROCESS.55': 'Labranza',
		'IMPLEMENT.PROCESS.56': 'Aseo',
		'IMPLEMENT.PROCESS.57': 'Trabajo de montaje',
		'IMPLEMENT.PROCESS.58': 'Entrada',
		'IMPLEMENT.PROCESS.59': 'Cargue y descargue',
		'IMPLEMENT.PROCESS.6': 'Cultivo',
		'IMPLEMENT.PROCESS.60': 'Lavado',
		'IMPLEMENT.PROCESS.61': 'Compactado',
		'IMPLEMENT.PROCESS.7': 'Desgarrado',
		'IMPLEMENT.PROCESS.8': 'Descompactado profundo',
		'IMPLEMENT.PROCESS.9': 'Desgarre',
		'IMPLEMENT.PROCESS.deadhead': 'Sin implemento',
		'IMPLEMENT.REMOVE': 'Quitar el implemento',
		'IMPLEMENT.RESOURCE.0': 'Indefinido',
		'IMPLEMENT.RESOURCE.1': 'Forraje',
		'IMPLEMENT.RESOURCE.10': 'Estiércol',
		'IMPLEMENT.RESOURCE.11': 'Lodos',
		'IMPLEMENT.RESOURCE.12': 'Compost',
		'IMPLEMENT.RESOURCE.13': 'Digestato',
		'IMPLEMENT.RESOURCE.14': 'Astillas de madera',
		'IMPLEMENT.RESOURCE.15': 'Maíz',
		'IMPLEMENT.RESOURCE.16': 'Girasol',
		'IMPLEMENT.RESOURCE.17': 'Sorgo',
		'IMPLEMENT.RESOURCE.18': 'Centeno',
		'IMPLEMENT.RESOURCE.19': 'Triticale',
		'IMPLEMENT.RESOURCE.2': 'Ensilado de hierba',
		'IMPLEMENT.RESOURCE.20': 'Trigo',
		'IMPLEMENT.RESOURCE.21': 'Alubia',
		'IMPLEMENT.RESOURCE.22': 'Guisante',
		'IMPLEMENT.RESOURCE.23': 'Césped de campo',
		'IMPLEMENT.RESOURCE.24': 'Hierba de trébol',
		'IMPLEMENT.RESOURCE.25': 'Cebada',
		'IMPLEMENT.RESOURCE.26': 'Avena',
		'IMPLEMENT.RESOURCE.27': 'Escanda',
		'IMPLEMENT.RESOURCE.28': 'Camelina',
		'IMPLEMENT.RESOURCE.29': 'Semillas de lino',
		'IMPLEMENT.RESOURCE.3': 'Ensilado de plantas enteras',
		'IMPLEMENT.RESOURCE.30': 'Colza',
		'IMPLEMENT.RESOURCE.31': 'Soja',
		'IMPLEMENT.RESOURCE.32': 'Captura de cosecha',
		'IMPLEMENT.RESOURCE.33': 'Remolacha azucarera',
		'IMPLEMENT.RESOURCE.34': 'Papas',
		'IMPLEMENT.RESOURCE.35': 'Miscanto',
		'IMPLEMENT.RESOURCE.36': 'Topinambur',
		'IMPLEMENT.RESOURCE.37': 'Vegetales',
		'IMPLEMENT.RESOURCE.38': 'Frutillas',
		'IMPLEMENT.RESOURCE.39': 'Abono líquido',
		'IMPLEMENT.RESOURCE.4': 'Heno',
		'IMPLEMENT.RESOURCE.40': 'Cal',
		'IMPLEMENT.RESOURCE.41': 'Diamonfosfato',
		'IMPLEMENT.RESOURCE.42': 'Pellets de harina de Haar, PK, K, P, KAS',
		'IMPLEMENT.RESOURCE.43': 'Urea',
		'IMPLEMENT.RESOURCE.44': 'Diesel',
		'IMPLEMENT.RESOURCE.45': 'AdBlue',
		'IMPLEMENT.RESOURCE.46': 'Suelo',
		'IMPLEMENT.RESOURCE.47': 'Protector de las plantas',
		'IMPLEMENT.RESOURCE.48': 'Varios',
		'IMPLEMENT.RESOURCE.49': 'Agua',
		'IMPLEMENT.RESOURCE.5': 'CCM',
		'IMPLEMENT.RESOURCE.50': 'Mezcla de piensos',
		'IMPLEMENT.RESOURCE.6': 'Maíz',
		'IMPLEMENT.RESOURCE.7': 'Paja',
		'IMPLEMENT.RESOURCE.8': 'Ensilado de maíz',
		'IMPLEMENT.RESOURCE.9': 'Grano',
		'IMPLEMENT.TYPE': 'Tipo de implemento',
		'IMPLEMENT.TYPE.1': 'Empacadoras / Enfardadoras',
		'IMPLEMENT.TYPE.10': 'Remolques de transporte',
		'IMPLEMENT.TYPE.10_1': 'Volquete de tres vías',
		'IMPLEMENT.TYPE.10_10': 'Remolque de plataforma baja',
		'IMPLEMENT.TYPE.10_11': 'Gancho elevador remolque',
		'IMPLEMENT.TYPE.10_12': 'Remolque para ganado',
		'IMPLEMENT.TYPE.10_13': 'Plataforma rodante para semirremolque',
		'IMPLEMENT.TYPE.10_14': 'Camiones cisterna/silo',
		'IMPLEMENT.TYPE.10_2': 'Volquete',
		'IMPLEMENT.TYPE.10_3': 'Papelera Chaser',
		'IMPLEMENT.TYPE.10_4': 'Plataforma remolque',
		'IMPLEMENT.TYPE.10_5': 'Remolque forrajero',
		'IMPLEMENT.TYPE.10_6': 'Remolque de ensilado',
		'IMPLEMENT.TYPE.10_7': 'Remolque de transporte de pacas',
		'IMPLEMENT.TYPE.10_8': 'Remolque de empuje',
		'IMPLEMENT.TYPE.10_9': 'Cisterna para estiércol líquido',
		'IMPLEMENT.TYPE.11': 'Equipamiento ganadero',
		'IMPLEMENT.TYPE.11_1': 'Mezcladora de alimentación arrastrada',
		'IMPLEMENT.TYPE.11_2': 'Vagón de distribución de forraje',
		'IMPLEMENT.TYPE.11_3': 'Vagón de recogida/distribución',
		'IMPLEMENT.TYPE.12': 'Silvicultura',
		'IMPLEMENT.TYPE.12_1': 'Remolque forestal',
		'IMPLEMENT.TYPE.12_2': 'Sierra para leña',
		'IMPLEMENT.TYPE.12_3': 'Procesadora de leña',
		'IMPLEMENT.TYPE.12_4': 'Cortadora de troncos',
		'IMPLEMENT.TYPE.12_5': 'Desbastadora de tocones',
		'IMPLEMENT.TYPE.12_6': 'Cabrestante forestal',
		'IMPLEMENT.TYPE.12_7': 'Trituradora forestal',
		'IMPLEMENT.TYPE.12_8': 'Astilladora',
		'IMPLEMENT.TYPE.12_8_1': 'Astilladora de disco montada',
		'IMPLEMENT.TYPE.12_8_2': 'Astilladora de disco arrastrado',
		'IMPLEMENT.TYPE.12_8_3': 'Astilladora de tambor montada',
		'IMPLEMENT.TYPE.12_8_4': 'Astilladora de tambor arrastrada',
		'IMPLEMENT.TYPE.12_8_5': 'Astilladora de tambor arrastrada (autopropulsada)',
		'IMPLEMENT.TYPE.12_9': 'Cortasetos hidráulico',
		'IMPLEMENT.TYPE.13': 'Equipamiento municipal',
		'IMPLEMENT.TYPE.13_1': 'Barredoras',
		'IMPLEMENT.TYPE.13_10': 'Dispositivo de mantenimiento de caminos',
		'IMPLEMENT.TYPE.13_11': 'Fresadora para banquetes',
		'IMPLEMENT.TYPE.13_12': 'Salero - montado',
		'IMPLEMENT.TYPE.13_13': 'Cargador',
		'IMPLEMENT.TYPE.13_14': 'Dispositivo de lavado',
		'IMPLEMENT.TYPE.13_15': 'Dispositivo de riego',
		'IMPLEMENT.TYPE.13_16': 'Plataforma de trabajo',
		'IMPLEMENT.TYPE.13_17': 'Trituradora de superficie',
		'IMPLEMENT.TYPE.13_18': 'Voladizo frontal',
		'IMPLEMENT.TYPE.13_18_1': 'Cabeza de segadora',
		'IMPLEMENT.TYPE.13_18_2': 'Cabezal para mantillo',
		'IMPLEMENT.TYPE.13_18_3': 'Cortasetos',
		'IMPLEMENT.TYPE.13_18_4': 'Cesta de compensación',
		'IMPLEMENT.TYPE.13_18_5': 'Rastrillo',
		'IMPLEMENT.TYPE.13_19': 'Centro voladizo / superestructura',
		'IMPLEMENT.TYPE.13_19_1': 'Cabeza de segadora',
		'IMPLEMENT.TYPE.13_19_2': 'Cabeza de segadora',
		'IMPLEMENT.TYPE.13_19_3': 'Cortasetos',
		'IMPLEMENT.TYPE.13_19_4': 'Cesta de limpieza',
		'IMPLEMENT.TYPE.13_19_5': 'Rastrillo',
		'IMPLEMENT.TYPE.13_1_1': 'Barredora frontal',
		'IMPLEMENT.TYPE.13_1_2': 'Barredora trasera',
		'IMPLEMENT.TYPE.13_1_3': 'Estructura',
		'IMPLEMENT.TYPE.13_2': 'Quitanieves',
		'IMPLEMENT.TYPE.13_20': 'Fijación trasera del balancín',
		'IMPLEMENT.TYPE.13_20_1': 'Cabeza de segadora',
		'IMPLEMENT.TYPE.13_20_2': 'Cabeza de trituradora',
		'IMPLEMENT.TYPE.13_20_3': 'Cortasetos',
		'IMPLEMENT.TYPE.13_20_4': 'Cesta de limpieza',
		'IMPLEMENT.TYPE.13_20_5': 'Rastrillo',
		'IMPLEMENT.TYPE.13_21': 'Soplador de hojas',
		'IMPLEMENT.TYPE.13_22': 'Compactador de banquetes / compactador de placas',
		'IMPLEMENT.TYPE.13_3': 'Cuchilla quitanieves - En V',
		'IMPLEMENT.TYPE.13_4': 'Soplador quitanieves',
		'IMPLEMENT.TYPE.13_5': 'Esparcidor montado',
		'IMPLEMENT.TYPE.13_6': 'Esparcidor remolcado',
		'IMPLEMENT.TYPE.13_7': 'Cortacésped de carretera',
		'IMPLEMENT.TYPE.13_8': 'Cortacésped de voladizo',
		'IMPLEMENT.TYPE.13_9': 'Segadora',
		'IMPLEMENT.TYPE.14': 'Equipos de carga frontal',
		'IMPLEMENT.TYPE.14_1': 'Cubo',
		'IMPLEMENT.TYPE.14_2': 'Cubo de gran volumen',
		'IMPLEMENT.TYPE.14_3': 'Horquilla para palets',
		'IMPLEMENT.TYPE.14_4': 'Pinza para balas',
		'IMPLEMENT.TYPE.14_5': 'Horquilla para balas',
		'IMPLEMENT.TYPE.14_6': 'Cuchara de agarre',
		'IMPLEMENT.TYPE.14_7': 'Plataforma de trabajo',
		'IMPLEMENT.TYPE.14_8': 'Horquilla para estiércol',
		'IMPLEMENT.TYPE.15': 'Adjuntos de cosecha',
		'IMPLEMENT.TYPE.15_1': 'Corte',
		'IMPLEMENT.TYPE.15_1_1': 'Norma de corte',
		'IMPLEMENT.TYPE.15_1_2': 'Corte plegable',
		'IMPLEMENT.TYPE.15_2': 'Recolector de maíz',
		'IMPLEMENT.TYPE.15_2_1': 'Recogedora de maíz estándar',
		'IMPLEMENT.TYPE.15_3': 'Cabecera de maíz',
		'IMPLEMENT.TYPE.15_4': 'Ensilado de plantas enteras',
		'IMPLEMENT.TYPE.15_5': 'Recogida',
		'IMPLEMENT.TYPE.15_6': 'Borrado de datos adjuntos',
		'IMPLEMENT.TYPE.15_7': 'Sistema de admisión',
		'IMPLEMENT.TYPE.15_8': 'Recogida de hileras',
		'IMPLEMENT.TYPE.16': 'Varios',
		'IMPLEMENT.TYPE.16_1': 'Molino CCM',
		'IMPLEMENT.TYPE.16_2': 'Peso delantero',
		'IMPLEMENT.TYPE.16_3': 'Peso trasero',
		'IMPLEMENT.TYPE.16_4': 'Cuchilla de empuje',
		'IMPLEMENT.TYPE.17': 'Huerto y viñedo',
		'IMPLEMENT.TYPE.17_1': 'Arado de desbroce',
		'IMPLEMENT.TYPE.17_2': 'Plantadora',
		'IMPLEMENT.TYPE.17_3': 'Defoliador',
		'IMPLEMENT.TYPE.17_4': 'Fresadora de portainjertos',
		'IMPLEMENT.TYPE.18': 'Cultivo de hortalizas',
		'IMPLEMENT.TYPE.18_1': 'Cosechadora de zanahorias',
		'IMPLEMENT.TYPE.18_2': 'Cosechadora de cebollas',
		'IMPLEMENT.TYPE.18_4': 'Cosechadora de bulbos',
		'IMPLEMENT.TYPE.18_5': 'Cosechadora de puerros',
		'IMPLEMENT.TYPE.19': 'Tecnología de la remolacha azucarera',
		'IMPLEMENT.TYPE.19_1': 'Cosechadora de remolacha azucarera - cosechadora de tolvas',
		'IMPLEMENT.TYPE.19_1_1': 'Cosechadora de búnkeres',
		'IMPLEMENT.TYPE.19_1_2': 'Sobrecargador',
		'IMPLEMENT.TYPE.1_1': 'Rotoempacadora',
		'IMPLEMENT.TYPE.1_2': 'Empacadora cuadrada',
		'IMPLEMENT.TYPE.1_3': 'Combinación de enfardado/enfardado',
		'IMPLEMENT.TYPE.1_4': 'Encintadora',
		'IMPLEMENT.TYPE.1_5': 'Empacadora de alta densidad',
		'IMPLEMENT.TYPE.2': 'Cultivo del suelo',
		'IMPLEMENT.TYPE.2_1': 'Arado',
		'IMPLEMENT.TYPE.2_10': 'Motoazada',
		'IMPLEMENT.TYPE.2_10_1': 'Motoazada montada',
		'IMPLEMENT.TYPE.2_10_2': 'Motocultores arrastrados',
		'IMPLEMENT.TYPE.2_11': 'Empaquetador frontal',
		'IMPLEMENT.TYPE.2_12': 'Rodillo',
		'IMPLEMENT.TYPE.2_12_1': 'Rodillo montado',
		'IMPLEMENT.TYPE.2_12_2': 'Rodillo arrastrado',
		'IMPLEMENT.TYPE.2_13': 'Gradas rotativas',
		'IMPLEMENT.TYPE.2_13_1': 'Gradas rotativas montadas',
		'IMPLEMENT.TYPE.2_13_2': 'Gradas rotativas arrastradas',
		'IMPLEMENT.TYPE.2_14': 'Cultivador rotatorio',
		'IMPLEMENT.TYPE.2_14_1': 'Rotocultor montado',
		'IMPLEMENT.TYPE.2_14_2': 'Rotocultor arrastrado',
		'IMPLEMENT.TYPE.2_15': 'Combinación de semilleros',
		'IMPLEMENT.TYPE.2_15_1': 'Combinación de semillero montado',
		'IMPLEMENT.TYPE.2_15_2': 'Combinación de semillero arrastrado',
		'IMPLEMENT.TYPE.2_16': 'Prensas',
		'IMPLEMENT.TYPE.2_17': 'Rascadores',
		'IMPLEMENT.TYPE.2_17_1': 'Rascadores montados',
		'IMPLEMENT.TYPE.2_17_2': 'Rascadores arrastrados',
		'IMPLEMENT.TYPE.2_18': 'Grada de paja',
		'IMPLEMENT.TYPE.2_18_1': 'Rastra de paja montada',
		'IMPLEMENT.TYPE.2_18_2': 'Grada de paja arrastrada',
		'IMPLEMENT.TYPE.2_19': 'Otros cultivadores',
		'IMPLEMENT.TYPE.2_19_1': 'Cultivadores adicionales montados',
		'IMPLEMENT.TYPE.2_19_2': 'Más cultivadores',
		'IMPLEMENT.TYPE.2_1_1': 'Arado montado',
		'IMPLEMENT.TYPE.2_1_2': 'Arado semisuspendido',
		'IMPLEMENT.TYPE.2_1_3': 'Arado semisuspendido (en tierra)',
		'IMPLEMENT.TYPE.2_2': 'Cultivador',
		'IMPLEMENT.TYPE.2_20': 'Otros cultivadores',
		'IMPLEMENT.TYPE.2_2_1': 'Cultivador montado',
		'IMPLEMENT.TYPE.2_2_2': 'Cultivador arrastrado',
		'IMPLEMENT.TYPE.2_3': 'Grada de discos',
		'IMPLEMENT.TYPE.2_3_1': 'Grada de discos montada',
		'IMPLEMENT.TYPE.2_3_2': 'Grada arrastrada',
		'IMPLEMENT.TYPE.2_4': 'Rastra de discos compactos',
		'IMPLEMENT.TYPE.2_4_1': 'Rastra de discos compactos montada',
		'IMPLEMENT.TYPE.2_4_2': 'Rastra compacta de discos arrastrada',
		'IMPLEMENT.TYPE.2_5': 'Aflojador',
		'IMPLEMENT.TYPE.2_5_1': 'Aflojador profundo montado',
		'IMPLEMENT.TYPE.2_5_2': 'Aflojatodo arrastrado',
		'IMPLEMENT.TYPE.2_6': 'Máquina pala',
		'IMPLEMENT.TYPE.2_6_1': 'Máquina pala montada',
		'IMPLEMENT.TYPE.2_6_2': 'Máquina pala arrastrada',
		'IMPLEMENT.TYPE.2_7': 'Grada rotativa',
		'IMPLEMENT.TYPE.2_7_1': 'Grada rotativa montada',
		'IMPLEMENT.TYPE.2_7_2': 'Grada rotativa arrastrada',
		'IMPLEMENT.TYPE.2_8': 'Azada rotativa',
		'IMPLEMENT.TYPE.2_8_1': 'Azada rotativa montada',
		'IMPLEMENT.TYPE.2_8_2': 'Azada rotatoria remolcada',
		'IMPLEMENT.TYPE.2_9': 'Grada rotativa',
		'IMPLEMENT.TYPE.2_9_1': 'Grada alternativa montada',
		'IMPLEMENT.TYPE.2_9_2': 'Grada alternativa arrastrada',
		'IMPLEMENT.TYPE.3': 'Sembradoras/Plantadoras',
		'IMPLEMENT.TYPE.3_1': 'Sembradora mecánica',
		'IMPLEMENT.TYPE.3_1_1': 'Sembradora montada',
		'IMPLEMENT.TYPE.3_1_2': 'Sembradora semisuspendida',
		'IMPLEMENT.TYPE.3_1_3': 'Combinación de siembra - montada',
		'IMPLEMENT.TYPE.3_1_4': 'Se,i combinación de siembra - montada',
		'IMPLEMENT.TYPE.3_2': 'Sembradora neumática',
		'IMPLEMENT.TYPE.3_2_1': 'Sembradora montada',
		'IMPLEMENT.TYPE.3_2_2': 'Sembradora semisuspendida',
		'IMPLEMENT.TYPE.3_2_3': 'Combinación de siembra - montada',
		'IMPLEMENT.TYPE.3_2_4': 'Combinación de siembra - semisuspendida',
		'IMPLEMENT.TYPE.3_3': 'sembradora mecánica de precisión',
		'IMPLEMENT.TYPE.3_3_1': 'Sembradora montada',
		'IMPLEMENT.TYPE.3_3_2': 'Sembradora semisuspendida',
		'IMPLEMENT.TYPE.3_3_3': 'Combinación de siembra - montada',
		'IMPLEMENT.TYPE.3_3_4': 'Combinación de siembra - semisuspendida',
		'IMPLEMENT.TYPE.3_4': 'Sembradora neumática de precisión',
		'IMPLEMENT.TYPE.3_4_1': 'Sembradora montada',
		'IMPLEMENT.TYPE.3_4_2': 'Sembradora semisuspendida',
		'IMPLEMENT.TYPE.3_4_3': 'Combinación de siembra - montada',
		'IMPLEMENT.TYPE.3_4_4': 'Combinación de siembra - semisuspendida',
		'IMPLEMENT.TYPE.3_5': 'Sembradora directa',
		'IMPLEMENT.TYPE.3_5_1': 'Sembradora directa montada',
		'IMPLEMENT.TYPE.3_5_2': 'Sembradora directa enganchada',
		'IMPLEMENT.TYPE.3_6': 'Sembradora monograno directa',
		'IMPLEMENT.TYPE.3_6_1': 'Sembradora directa de grano único montada',
		'IMPLEMENT.TYPE.3_6_2': 'Sembradora directa de grano único acoplada',
		'IMPLEMENT.TYPE.3_7': 'Jardinera',
		'IMPLEMENT.TYPE.3_7_1': 'Jardinera montada',
		'IMPLEMENT.TYPE.3_7_2': 'Plantadora - acoplada',
		'IMPLEMENT.TYPE.3_8': 'Sembradora de césped',
		'IMPLEMENT.TYPE.3_8_1': 'Pradera cultivada',
		'IMPLEMENT.TYPE.3_8_2': 'Resembrador de praderas adjunto',
		'IMPLEMENT.TYPE.3_9': 'Depósito frontal',
		'IMPLEMENT.TYPE.4': 'Esparcidor',
		'IMPLEMENT.TYPE.4_1': 'Esparcidor montado',
		'IMPLEMENT.TYPE.4_2': 'Esparcidor semisuspendido',
		'IMPLEMENT.TYPE.5': 'Protección de las plantas',
		'IMPLEMENT.TYPE.5_1': 'Pulverizador montado',
		'IMPLEMENT.TYPE.5_2': 'Pulverizador arrastrado',
		'IMPLEMENT.TYPE.5_3': 'Azada',
		'IMPLEMENT.TYPE.5_3_1': 'Azada montada',
		'IMPLEMENT.TYPE.5_3_2': 'Azada remolcada',
		'IMPLEMENT.TYPE.5_4': 'Desbrozadora',
		'IMPLEMENT.TYPE.5_4_1': 'Desbrozadora montada',
		'IMPLEMENT.TYPE.5_4_2': 'Desbrozadora arrastrada',
		'IMPLEMENT.TYPE.6': 'Tecnología del estiércol',
		'IMPLEMENT.TYPE.6_1': 'Esparcidor de estiércol/compost',
		'IMPLEMENT.TYPE.6_2': 'Cisterna para estiércol',
		'IMPLEMENT.TYPE.6_2_1': 'Difusor exacto',
		'IMPLEMENT.TYPE.6_2_2': 'Brazo de manguera de goteo',
		'IMPLEMENT.TYPE.6_2_3': 'Esparcidor de zapata de arrastre',
		'IMPLEMENT.TYPE.6_2_4': 'Inyector del cultivador',
		'IMPLEMENT.TYPE.6_2_5': 'Rastra de discos inyectora',
		'IMPLEMENT.TYPE.6_2_6': 'Inyector cortador de disco',
		'IMPLEMENT.TYPE.6_2_7': 'Inyector Striptill',
		'IMPLEMENT.TYPE.6_2_8': 'Distribuidores giratorios',
		'IMPLEMENT.TYPE.6_3': 'Bomba de lodo',
		'IMPLEMENT.TYPE.6_4': 'Mezcladora de lodos',
		'IMPLEMENT.TYPE.6_5': 'Contenedor de estiércol',
		'IMPLEMENT.TYPE.6_6': 'Sistema de mangueras',
		'IMPLEMENT.TYPE.6_6_1': 'Distribuidor de mangueras de arrastre',
		'IMPLEMENT.TYPE.6_6_2': 'Distribuidor de zapatas de arrastre',
		'IMPLEMENT.TYPE.6_6_3': 'Inyector de disco de estiércol',
		'IMPLEMENT.TYPE.6_6_4': 'Cultivador de estiércol',
		'IMPLEMENT.TYPE.6_6_5': 'Grada de discos para estiércol',
		'IMPLEMENT.TYPE.6_6_6': 'Inyector de estiércol',
		'IMPLEMENT.TYPE.6_6_7': 'Distribuidor giratorio',
		'IMPLEMENT.TYPE.7': 'Tecnología de riego',
		'IMPLEMENT.TYPE.7_1': 'Viajero de riego',
		'IMPLEMENT.TYPE.7_2': 'Barra de riego',
		'IMPLEMENT.TYPE.8': 'Equipamiento para papas',
		'IMPLEMENT.TYPE.8_1': 'Sembradora de papa',
		'IMPLEMENT.TYPE.8_1_1': 'Sembradora sin rotocultivador',
		'IMPLEMENT.TYPE.8_1_2': 'Sembradora con rotocultivador',
		'IMPLEMENT.TYPE.8_1_3': 'Sembradora sin rotocultivador (arrastrada)',
		'IMPLEMENT.TYPE.8_1_4': 'Sembradora con motoazada (montada)',
		'IMPLEMENT.TYPE.8_2': 'Cosechadora de papa - hileradora',
		'IMPLEMENT.TYPE.8_3': 'Cosechadora de papa- con tolva',
		'IMPLEMENT.TYPE.8_4': 'Cosechadora de papa - elevador',
		'IMPLEMENT.TYPE.8_5': 'Cumbrera antigua',
		'IMPLEMENT.TYPE.8_6': 'Separador',
		'IMPLEMENT.TYPE.8_7': 'Motoazada',
		'IMPLEMENT.TYPE.8_8': 'Desbrozadora de hojas',
		'IMPLEMENT.TYPE.9': 'Equipamiento para pastos',
		'IMPLEMENT.TYPE.9_1': 'Segadora de tambores',
		'IMPLEMENT.TYPE.9_1_1': 'Segadora de tambores con acondicionador',
		'IMPLEMENT.TYPE.9_1_2': 'Segadora de tambores sin acondicionador',
		'IMPLEMENT.TYPE.9_1_3': 'Segadora de tambores con acondicionador (montada)',
		'IMPLEMENT.TYPE.9_1_4': 'Segadora de tambores sin acondicionador (arrastrada)',
		'IMPLEMENT.TYPE.9_2': 'Segadora de discos',
		'IMPLEMENT.TYPE.9_2_1': 'Segadora de discos con acondicionador',
		'IMPLEMENT.TYPE.9_2_2': 'Segadora de discos sin acondicionador',
		'IMPLEMENT.TYPE.9_2_3': 'Segadora de discos con acondicionador (montada)',
		'IMPLEMENT.TYPE.9_2_4': 'Segadora de discos sin acondicionador (arrastrada)',
		'IMPLEMENT.TYPE.9_3': 'Henificador rotativo',
		'IMPLEMENT.TYPE.9_3_1': 'Henificador rotativo (montado)',
		'IMPLEMENT.TYPE.9_3_2': 'Henificador rotativo (arrastrado)',
		'IMPLEMENT.TYPE.9_4': 'Hileradora',
		'IMPLEMENT.TYPE.9_4_1': 'Hileradora monorotor',
		'IMPLEMENT.TYPE.9_4_2': 'Hileradora de doble rotor (hilerado lateral)',
		'IMPLEMENT.TYPE.9_4_3': 'Hileradora de doble rotor (hilerado central)',
		'IMPLEMENT.TYPE.9_4_4': 'Hileradora de cuatro rotores',
		'IMPLEMENT.TYPE.9_4_5': 'Fusión continua',
		'IMPLEMENT.TYPE.9_4_6': 'Rastrillo giratorio',
		'IMPLEMENT.TYPE.9_5': 'Grada de hierba',
		'IMPLEMENT.TYPE.9_6': 'Rastra de pasto',
		'IMPLEMENT.TYPE.9_7': 'Rodillo de pradera',
		'IMPLEMENT.TYPE.9_8': 'Helicóptero',
		'IMPLEMENTS': 'Implementos',
		'IMPLEMENTS.ALL': 'Todos los implementos',
		'IMPLEMENTS.DEACTIVATE.FAILURE': 'Algunos de los implementos no podían desactivarse.',
		'IMPLEMENTS.DEACTIVATE.QUESTION': '¿Realmente quieres desactivar los implementos seleccionados?',
		'IMPLEMENTS.DEACTIVATE.SUCCESS': 'Implementos desactivados con éxito',
		'IMPLEMENTS.DELETE.FAILURE': 'Algunos de los implementos no se han podido eliminar.',
		'IMPLEMENTS.DELETE.QUESTION': '¿Realmente desea borrar los implementos seleccionados?',
		'IMPLEMENTS.DELETE.SUCCESS': 'Se han eliminado los implementos',
		'IMPLEMENTS.MANAGEMENT': 'Gestión de implementos',
		'IMPLEMENTS.NO': 'Sin implementos',
		'IMPLEMENTS.NOT_SELECTED': 'No se han seleccionado implementos',
		'IMPLEMENTS.REACTIVATE.FAILURE': 'Algunos de los implementos no pudieron reactivarse.',
		'IMPLEMENTS.REACTIVATE.QUESTION': '¿Realmente quieres reactivar los implementos seleccionados?',
		'IMPLEMENTS.REACTIVATE.SUCCESS': 'Implements reactivated successfully',
		'IMPLEMENTS.SELECTED': 'Implementos seleccionadas',
		'IMPLEMENT_SCAN_DISABLED': 'Inactivar beacon de implemento',
		'IMPORT': 'Importar',
		'INACTIVE': 'Inactivo',
		'INDIVIDUAL_LABELING': 'Etiquetado personalizado',
		'INFO': 'Información',
		'INTERPOLATION.MAP': 'Mapa de interpolación',
		'INTERPOLATION.MAP.SETTINGS': 'Ajustes del mapa de interpolación',
		'IO_BOX_ACTIVATED': 'IOBox activo',
		'ISOBUS.DDI.1': 'Volumen consigna por área de  tasa de aplicación',
		'ISOBUS.DDI.10': 'Masa máxima por superficie de tasa de aplicación',
		'ISOBUS.DDI.100': 'Contaminación de los cultivos',
		'ISOBUS.DDI.101': 'Punto fijo de anchura de bala',
		'ISOBUS.DDI.102': 'Anchura real de la bala',
		'ISOBUS.DDI.103': 'Anchura de bala por defecto',
		'ISOBUS.DDI.104': 'Ancho mínimo de bala',
		'ISOBUS.DDI.105': 'Ancho máximo de bala',
		'ISOBUS.DDI.106': 'Valor de consigna de altura de bala',
		'ISOBUS.DDI.107': 'Altura real de paca',
		'ISOBUS.DDI.108': 'Altura de bala por defecto',
		'ISOBUS.DDI.109': 'Altura mínima de bala',
		'ISOBUS.DDI.11': 'Recuento consigna por área de tasa de aplicación',
		'ISOBUS.DDI.110': 'Altura máxima de bala',
		'ISOBUS.DDI.111': 'Valor consigna de tamaño de bala',
		'ISOBUS.DDI.112': 'Tamaño real de la bala',
		'ISOBUS.DDI.113': 'Tamaño de bala por defecto',
		'ISOBUS.DDI.114': 'Tamaño mínimo de bala',
		'ISOBUS.DDI.115': 'Tamaño máximo de bala',
		'ISOBUS.DDI.116': 'Superficie total',
		'ISOBUS.DDI.117': 'Distancia total efectiva',
		'ISOBUS.DDI.118': 'Distancia total inefectiva',
		'ISOBUS.DDI.119': 'Tiempo total efectivo',
		'ISOBUS.DDI.12': 'Recuento real por área de tasa de aplicación',
		'ISOBUS.DDI.120': 'Tiempo total ineficiente',
		'ISOBUS.DDI.121': 'Densidad del producto en masa por volumen',
		'ISOBUS.DDI.122': 'Densidad del producto en masa por recuento',
		'ISOBUS.DDI.123': 'Densidad del producto en masa por volumen',
		'ISOBUS.DDI.124': 'Extensión de escala de válvula auxiliar',
		'ISOBUS.DDI.125': 'Retracción de escala de válvula auxiliar',
		'ISOBUS.DDI.126': 'Rampa de válvula auxiliar extendida hacia arriba',
		'ISOBUS.DDI.127': 'Rampa de válvula auxiliar extendida hacia abajo',
		'ISOBUS.DDI.128': 'Retracción de rampa de válvula auxiliar hacia arriba',
		'ISOBUS.DDI.129': 'Retracción de rampa de válvula auxiliar hacia abajo',
		'ISOBUS.DDI.13': 'Recuento predeterminado por tasa de aplicación de área',
		'ISOBUS.DDI.130': 'Umbral de flotación de válvula auxiliar',
		'ISOBUS.DDI.131': 'Extensión de progresividad de válvula auxiliar',
		'ISOBUS.DDI.132': 'Retracción de progresividad de válvula auxiliar',
		'ISOBUS.DDI.133': 'Puertos de inversión de válvula auxiliar',
		'ISOBUS.DDI.134': 'Desplazamiento del elemento del dispositivo X',
		'ISOBUS.DDI.135': 'Desplazamiento del elemento del dispositivo Y',
		'ISOBUS.DDI.136': 'Desplazamiento del elemento del dispositivo Z',
		'ISOBUS.DDI.137': 'Capacidad de volumen del dispositivo',
		'ISOBUS.DDI.138': 'Capacidad de masa del dispositivo',
		'ISOBUS.DDI.139': 'Capacidad de recuento de dispositivos',
		'ISOBUS.DDI.14': 'Recuento mínimo por área de dosis de aplicación',
		'ISOBUS.DDI.140': 'Porcentaje de consigna de tasa de aplicación',
		'ISOBUS.DDI.141': 'Estado actual del trabajo',
		'ISOBUS.DDI.142': 'Tiempo de consigna física de latencia',
		'ISOBUS.DDI.143': 'Físico Valor real Tiempo Latencia',
		'ISOBUS.DDI.144': 'Ángulo de guiñada',
		'ISOBUS.DDI.145': 'Ángulo de balanceo',
		'ISOBUS.DDI.146': 'Ángulo de paso',
		'ISOBUS.DDI.147': 'Recuento de registros',
		'ISOBUS.DDI.148': 'Consumo total de combustible',
		'ISOBUS.DDI.149': 'Consumo de combustible por tiempo',
		'ISOBUS.DDI.15': 'Conteo máximo por área de tasa de aplicación',
		'ISOBUS.DDI.150': 'Consumo de combustible por superficie',
		'ISOBUS.DDI.151': 'Superficie por tiempo de capacidad',
		'ISOBUS.DDI.153': 'Índice vegetativo de diferencia normalizada (NDVI) real',
		'ISOBUS.DDI.154': 'Longitud del objeto físico',
		'ISOBUS.DDI.155': 'Anchura del objeto físico',
		'ISOBUS.DDI.156': 'Altura del objeto físico',
		'ISOBUS.DDI.157': 'Tipo de conector',
		'ISOBUS.DDI.158': 'Estado del control de las recetas',
		'ISOBUS.DDI.159': 'Número de subunidades por sección',
		'ISOBUS.DDI.16': 'Distancia entre puntos de consigna por tasa de aplicación',
		'ISOBUS.DDI.160': 'Sección Control de Estado',
		'ISOBUS.DDI.161': 'Estado de trabajo condensado real (1-16)',
		'ISOBUS.DDI.162': 'Estado de trabajo condensado real (17-32)',
		'ISOBUS.DDI.163': 'Estado de trabajo condensado real (33-48)',
		'ISOBUS.DDI.164': 'Estado de trabajo condensado real (49-64)',
		'ISOBUS.DDI.165': 'Estado de trabajo condensado real (65-80)',
		'ISOBUS.DDI.166': 'Estado de trabajo condensado real (81-96)',
		'ISOBUS.DDI.167': 'Estado de trabajo condensado real (97-112)',
		'ISOBUS.DDI.168': 'Estado de trabajo condensado real (113-128)',
		'ISOBUS.DDI.169': 'Estado de trabajo condensado real (129-144) ',
		'ISOBUS.DDI.17': 'Tasa de aplicación de espaciado real',
		'ISOBUS.DDI.170': 'Estado de trabajo condensado real  (145-160) ',
		'ISOBUS.DDI.171': 'Estado de trabajo condensado real  (161-176) ',
		'ISOBUS.DDI.172': 'Estado de trabajo condensado real (177-192) ',
		'ISOBUS.DDI.173': 'Estado de trabajo condensado real (193-208)',
		'ISOBUS.DDI.174': 'Estado de trabajo condensado real (209-224)',
		'ISOBUS.DDI.175': 'Estado de trabajo condensado real (225-240)',
		'ISOBUS.DDI.176': 'Estado de trabajo condensado real (241-256)',
		'ISOBUS.DDI.177': 'Longitud real de corte',
		'ISOBUS.DDI.178': 'Instancia Tipo de elemento',
		'ISOBUS.DDI.179': 'Práctica cultural real',
		'ISOBUS.DDI.18': 'Tasa de aplicación de espaciado predeterminada',
		'ISOBUS.DDI.180': 'Distancia del punto de referencia del dispositivo (DRP) a tierra',
		'ISOBUS.DDI.181': 'Massa Seca por área de rendimento',
		'ISOBUS.DDI.182': 'Rendimiento de masa seca por tiempo',
		'ISOBUS.DDI.183': 'Rendimiento en masa seca total',
		'ISOBUS.DDI.184': 'Humedad de referencia para masa seca',
		'ISOBUS.DDI.185': 'Rendimiento en masa por área de algodón en rama',
		'ISOBUS.DDI.186': 'Algodón pelusa en masa por área de rendimiento',
		'ISOBUS.DDI.187': 'Semilla de algodón en masa por tiempo de rendimiento',
		'ISOBUS.DDI.188': 'Rendimiento de masa de algodón de pelusa por tiempo',
		'ISOBUS.DDI.189': 'Rendimiento en masa total de algodón en rama',
		'ISOBUS.DDI.19': 'Espaciado mínimo de dosis de aplicación',
		'ISOBUS.DDI.190': 'Rendimiento en masa total de algodón de pelusa',
		'ISOBUS.DDI.191': 'Porcentaje de giro de la pelusa',
		'ISOBUS.DDI.192': 'Temperatura ambiente',
		'ISOBUS.DDI.193': 'Presión consigna del producto',
		'ISOBUS.DDI.194': 'Presión real del producto',
		'ISOBUS.DDI.195': 'Mínima presión del producto',
		'ISOBUS.DDI.196': 'Presión máxima del producto',
		'ISOBUS.DDI.197': 'Presión de salida de la bomba consigna',
		'ISOBUS.DDI.198': 'Presión real de salida de la bomba',
		'ISOBUS.DDI.199': 'Presión mínima de salida de la bomba',
		'ISOBUS.DDI.2': 'Volumen real por área de tasa de aplicación',
		'ISOBUS.DDI.20': 'Espaciado máximo de dosis de aplicación',
		'ISOBUS.DDI.200': 'Presión máxima del producto',
		'ISOBUS.DDI.201': 'Valor de consigna de Presión de agitación del depósito',
		'ISOBUS.DDI.202': 'Presión real de agitación del tanque',
		'ISOBUS.DDI.203': 'Presión mínima de agitación del depósito',
		'ISOBUS.DDI.204': 'Presión máxima de agitación del depósito',
		'ISOBUS.DDI.205': 'SC Tiempo de encendido',
		'ISOBUS.DDI.206': 'Tiempo de apagado SC',
		'ISOBUS.DDI.207': 'Velocidad del viento',
		'ISOBUS.DDI.208': 'Dirección del viento',
		'ISOBUS.DDI.209': 'Humedad relativa',
		'ISOBUS.DDI.21': 'Volumen de consigna por volumen tasa de aplicación',
		'ISOBUS.DDI.210': 'Condiciones del cielo',
		'ISOBUS.DDI.211': 'Última paca de copos por paca',
		'ISOBUS.DDI.212': 'Humedad media de la última paca',
		'ISOBUS.DDI.213': 'Última paca promedio de golpes por escama',
		'ISOBUS.DDI.214': 'Recuento total de balas',
		'ISOBUS.DDI.215': 'Total de horas de trabajo',
		'ISOBUS.DDI.216': 'Presión hidráulica real de la bala',
		'ISOBUS.DDI.217': 'Última bala de Presión hidráulica media',
		'ISOBUS.DDI.218': 'Punto de ajuste de Compresión de la bala de Carga del émbolo',
		'ISOBUS.DDI.219': 'Carga real del émbolo de compresión de la bala',
		'ISOBUS.DDI.22': 'Volumen real por volumen de tasa de aplicación',
		'ISOBUS.DDI.220': 'Última paca Compresión media de la paca de carga del émbolo',
		'ISOBUS.DDI.221': 'Última bala aplicada ',
		'ISOBUS.DDI.222': 'Número de etiqueta de la última paca',
		'ISOBUS.DDI.223': 'Última paca',
		'ISOBUS.DDI.224': ' Delta T ',
		'ISOBUS.DDI.225': 'Longitud de trabajo de consigna',
		'ISOBUS.DDI.226': 'Longitud real de trabajo',
		'ISOBUS.DDI.227': 'Longitud mínima de trabajo',
		'ISOBUS.DDI.228': ' Longitud máxima de trabajo ',
		'ISOBUS.DDI.229': 'Peso neto real',
		'ISOBUS.DDI.23': 'Tasa de aplicación por volumen por defecto',
		'ISOBUS.DDI.230': 'Peso neto Estado',
		'ISOBUS.DDI.231': 'Peso neto de consigna',
		'ISOBUS.DDI.232': 'Peso bruto real',
		'ISOBUS.DDI.233': 'Estado del peso bruto ',
		'ISOBUS.DDI.234': 'Peso bruto mínimo',
		'ISOBUS.DDI.235': 'Peso bruto máximo',
		'ISOBUS.DDI.236': 'Trilladora Tiempo total',
		'ISOBUS.DDI.237': 'Estado real de la altura de trabajo del cabezal',
		'ISOBUS.DDI.238': 'Estado de velocidad de rotación real del cabezal',
		'ISOBUS.DDI.239': 'Estado de retención de rendimientos',
		'ISOBUS.DDI.24': 'Volumen mínimo por volumen de tasa de aplicación',
		'ISOBUS.DDI.240': 'Estado real del sistema de descarga',
		'ISOBUS.DDI.241': 'Temperatura de los cultivos',
		'ISOBUS.DDI.242': 'Punto de consigna de distancia del tamiz',
		'ISOBUS.DDI.243': 'Distancia real entre tamices',
		'ISOBUS.DDI.244': 'Distancia mínima entre tamices',
		'ISOBUS.DDI.245': 'Distancia máxima entre tamices',
		'ISOBUS.DDI.246': 'Espacio libre consigna de la zaranda ',
		'ISOBUS.DDI.247': 'Despeje real de Chaffer',
		'ISOBUS.DDI.248': 'Distancia mínima de la zaranda ',
		'ISOBUS.DDI.249': 'Distancia máxima de la zaranda ',
		'ISOBUS.DDI.25': 'Volumen máximo por volumen de tasa de aplicación',
		'ISOBUS.DDI.250': 'Distancia cóncava de consigna',
		'ISOBUS.DDI.251': 'Espacio libre cóncavo real',
		'ISOBUS.DDI.252': 'Distancia mínima del cóncavo ',
		'ISOBUS.DDI.253': 'Distancia máxima del cóncavo',
		'ISOBUS.DDI.254': 'Separación de velocidad de giro del ventilador consigna',
		'ISOBUS.DDI.255': 'Separación de velocidad de rotación del ventilador real ',
		'ISOBUS.DDI.256': 'Separación de velocidad de rotación del ventilador mínima ',
		'ISOBUS.DDI.257': 'Separación máxima velocidad de rotación del ventilador',
		'ISOBUS.DDI.258': 'Temperatura del aceite hidráulico',
		'ISOBUS.DDI.259': 'Rendimiento retraso - Ignorar Tiempo',
		'ISOBUS.DDI.26': 'Masa por masa de tasa de aplicación consigna',
		'ISOBUS.DDI.260': 'Rendimiento - Ignorar Tiempo',
		'ISOBUS.DDI.261': 'Rendimiento medio en masa por tiempo',
		'ISOBUS.DDI.262': 'Humedad media del cultivo',
		'ISOBUS.DDI.263': 'Rendimiento medio en masa por superficie',
		'ISOBUS.DDI.264': 'Conector Pivote X-Offset',
		'ISOBUS.DDI.265': 'Superficie restante',
		'ISOBUS.DDI.266': 'Aplicación total de masa total ',
		'ISOBUS.DDI.267': 'Recuento total de recuento de aplicaciones ',
		'ISOBUS.DDI.268': 'Volumen total de rendimiento total',
		'ISOBUS.DDI.269': 'Masa total de rendimiento total',
		'ISOBUS.DDI.27': 'Tasa de aplicación de masa real por masa',
		'ISOBUS.DDI.270': 'Recuento total de rendimiento total',
		'ISOBUS.DDI.271': 'Área total',
		'ISOBUS.DDI.272': 'Distancia total efectiva ',
		'ISOBUS.DDI.273': 'Distancia total ineficaz ',
		'ISOBUS.DDI.274': 'Tiempo total efectivo ',
		'ISOBUS.DDI.275': 'Total ineficaz de tiempo total',
		'ISOBUS.DDI.276': 'Consumo de combustible de por vida',
		'ISOBUS.DDI.277': 'Consumo medio de combustible por tiempo',
		'ISOBUS.DDI.278': 'Consumo medio de combustible por área',
		'ISOBUS.DDI.279': 'Rendimiento total en masa seca total',
		'ISOBUS.DDI.28': 'Masa por masa de tasa de aplicación por defecto',
		'ISOBUS.DDI.280': 'Rendimiento total de masa total de algodón de siembra',
		'ISOBUS.DDI.281': 'Rendimiento total de pelusa de algodón en masa',
		'ISOBUS.DDI.282': 'Compromiso de trilla de por vida en tiempo total',
		'ISOBUS.DDI.283': 'Recuento total precortado',
		'ISOBUS.DDI.284': 'Recuento total sin cortar',
		'ISOBUS.DDI.285': 'Recuento total precortado de por vida',
		'ISOBUS.DDI.286': 'Recuento total sin cortes de por vida',
		'ISOBUS.DDI.287': 'Modo de prescripción de punto de ajuste',
		'ISOBUS.DDI.288': 'Modo de prescripción real',
		'ISOBUS.DDI.289': 'Consigna de estado de trabajo',
		'ISOBUS.DDI.29': 'Masa mínima por dosis de aplicación en masa',
		'ISOBUS.DDI.290': 'Consigna Condensada Estado de Trabajo (1-16)',
		'ISOBUS.DDI.291': 'Consigna Condensada Estado de Trabajo (17-32) ',
		'ISOBUS.DDI.292': 'Consigna Condensada Estado de trabajo  (33-48) ',
		'ISOBUS.DDI.293': 'Consigna Condensada Estado de trabajo (49-64) ',
		'ISOBUS.DDI.294': 'Consigna Condensada Estado de Trabajo (65-80)',
		'ISOBUS.DDI.295': 'Consigna Condensada Estado de Trabajo  (81-96) ',
		'ISOBUS.DDI.296': 'Consigna Condensada Estado de trabajo (97-112) ',
		'ISOBUS.DDI.297': 'Consigna Condensada Estado de Trabajo (113-128)',
		'ISOBUS.DDI.298': 'Estado de trabajo condensado de consigna (129-144)',
		'ISOBUS.DDI.299': 'Consigna Condensada Estado de Trabajo (145-160)',
		'ISOBUS.DDI.3': 'Tasa de aplicación de volumen por área predeterminada',
		'ISOBUS.DDI.30': 'Tasa máxima de aplicación de masa por masa',
		'ISOBUS.DDI.300': 'Estado de trabajo condensado de consigna (161-176)',
		'ISOBUS.DDI.301': 'Consigna Condensada Estado de Trabajo (177-192)',
		'ISOBUS.DDI.302': 'Estado de trabajo condensado de consigna (193-208)',
		'ISOBUS.DDI.303': 'Estado de trabajo condensado de consigna (209-224)',
		'ISOBUS.DDI.304': 'Consigna Condensada Estado de Trabajo (225-240)',
		'ISOBUS.DDI.305': 'Estado de trabajo condensado de consigna (241-256)',
		'ISOBUS.DDI.306': 'Desplazamiento X del punto de rotación verdadero',
		'ISOBUS.DDI.307': 'Desplazamiento Y del punto de rotación verdadero',
		'ISOBUS.DDI.308': 'Porcentaje real de tasa de aplicación',
		'ISOBUS.DDI.309': 'Tasa de aplicación de porcentaje mínimo',
		'ISOBUS.DDI.31': 'Volumen consigna por tasa de aplicación de masa',
		'ISOBUS.DDI.310': 'Tasa de aplicación de porcentaje máximo',
		'ISOBUS.DDI.311': 'Potencial de rendimiento relativo',
		'ISOBUS.DDI.312': 'Potencial de rendimiento mínimo relativo',
		'ISOBUS.DDI.313': 'Potencial de rendimiento máximo relativo',
		'ISOBUS.DDI.314': 'Porcentaje real de materia seca del cultivo',
		'ISOBUS.DDI.315': 'Porcentaje medio de materia seca del cultivo',
		'ISOBUS.DDI.316': 'Consumo total efectivo de combustible',
		'ISOBUS.DDI.317': 'Consumo total de combustible ineficiente',
		'ISOBUS.DDI.318': 'Consumo efectivo total de fluido de escape diésel',
		'ISOBUS.DDI.319': 'Consumo total ineficaz de fluido de escape diésel',
		'ISOBUS.DDI.32': 'Volumen real por tasa de aplicación en masa',
		'ISOBUS.DDI.320': 'Último peso cargado',
		'ISOBUS.DDI.321': 'Último peso descargado',
		'ISOBUS.DDI.322': 'Número de identificación de la carga',
		'ISOBUS.DDI.323': 'Número de identificación de descarga',
		'ISOBUS.DDI.324': 'Tiempo total de enganche del helicóptero',
		'ISOBUS.DDI.325': 'Volumen total de aplicaciones de por vida',
		'ISOBUS.DDI.326': 'Velocidad del encabezado del punto de ajuste',
		'ISOBUS.DDI.327': 'Velocidad real del encabezado',
		'ISOBUS.DDI.328': 'Velocidad mínima del encabezado',
		'ISOBUS.DDI.329': 'Velocidad máxima del encabezado',
		'ISOBUS.DDI.33': 'Volumen por defecto por tasa de aplicación en masa',
		'ISOBUS.DDI.330': 'Velocidad del tambor de corte consigna',
		'ISOBUS.DDI.331': 'Velocidad real del tambor de corte',
		'ISOBUS.DDI.332': 'Velocidad mínima del tambor de corte',
		'ISOBUS.DDI.333': 'Velocidad máxima del tambor de corte',
		'ISOBUS.DDI.334': 'Horas de funcionamiento desde el último afilado',
		'ISOBUS.DDI.335': 'Horas TDF delantera',
		'ISOBUS.DDI.336': 'Horas TDF trasera',
		'ISOBUS.DDI.337': 'Horas de TDF delantera total',
		'ISOBUS.DDI.338': 'Horas de la TDF trasera total',
		'ISOBUS.DDI.339': 'Tiempo total efectivo de carga',
		'ISOBUS.DDI.34': 'Volumen mínimo por tasa de aplicación en masa',
		'ISOBUS.DDI.340': 'Tiempo total efectivo de descarga',
		'ISOBUS.DDI.341': 'Brecha consigna de cereales en grano y el cracker',
		'ISOBUS.DDI.342': 'Brecha real de cereales en grano y el cracker',
		'ISOBUS.DDI.343': 'Brecha mínima entre el grano y el cracker',
		'ISOBUS.DDI.344': 'Brecha máxima entre el grano y el cracker',
		'ISOBUS.DDI.345': 'Anchura de hilera nominal',
		'ISOBUS.DDI.346': 'Anchura real de hilera',
		'ISOBUS.DDI.347': 'Anchura mínima de hilera',
		'ISOBUS.DDI.348': 'Anchura máxima de hilerado',
		'ISOBUS.DDI.349': 'Reducción de la deriva de la boquilla',
		'ISOBUS.DDI.35': 'Volumen máximo por tasa de aplicación en masa',
		'ISOBUS.DDI.350': 'Función u operación técnica',
		'ISOBUS.DDI.351': 'Volumen total de aplicación ',
		'ISOBUS.DDI.352': 'Masa total de aplicación ',
		'ISOBUS.DDI.353': 'Aplicación total de nitrógeno',
		'ISOBUS.DDI.354': 'Aplicación total de amonio',
		'ISOBUS.DDI.355': 'Aplicación total de fósforo',
		'ISOBUS.DDI.356': 'Aplicación total de potasio',
		'ISOBUS.DDI.357': 'Aplicación total de materia seca',
		'ISOBUS.DDI.358': 'Rendimiento medio en masa seca por tiempo',
		'ISOBUS.DDI.359': 'Rendimiento promedio en materia seca por superficie',
		'ISOBUS.DDI.36': 'Volumen de consigna por tiempo de tasa de aplicación',
		'ISOBUS.DDI.360': 'Tamaño de la última bala',
		'ISOBUS.DDI.361': 'Densidad de la última bala',
		'ISOBUS.DDI.362': 'Longitud total de la bala',
		'ISOBUS.DDI.363': 'Masa seca de última bala',
		'ISOBUS.DDI.364': 'Tamaño real del copo',
		'ISOBUS.DDI.365': 'Presión de descenso consigna ',
		'ISOBUS.DDI.366': 'Fuerza descendente de presión real',
		'ISOBUS.DDI.367': 'Sección condensada Estado de anulación (1-16)',
		'ISOBUS.DDI.368': 'Sección condensada Estado de anulación (17-32) ',
		'ISOBUS.DDI.369': 'Sección condensada Estado de anulación (33-48)',
		'ISOBUS.DDI.37': 'Tasa de aplicación en volumen real por tiempo ',
		'ISOBUS.DDI.370': 'Sección condensada Anulación Estado (49-64)',
		'ISOBUS.DDI.371': 'Sección condensada Anulación Estado (113-128)',
		'ISOBUS.DDI.372': 'Sección condensada Estado de anulación (81-96)',
		'ISOBUS.DDI.373': 'Consigna Condensada Estado de trabajo  (97-112) ',
		'ISOBUS.DDI.374': 'Sección condensada Anulación Estado (113-128)',
		'ISOBUS.DDI.375': 'Sección condensada Estado de anulación (129-144)',
		'ISOBUS.DDI.376': 'Sección condensada Estado de anulación (145-160)',
		'ISOBUS.DDI.377': 'Sección condensada Estado de anulación (161-176)',
		'ISOBUS.DDI.378': 'Sección condensada Estado de anulación (177-192)',
		'ISOBUS.DDI.379': 'Estado de anulación de la sección condensada (193-208) ',
		'ISOBUS.DDI.38': 'Volumen por defecto por tiempo de aplicación',
		'ISOBUS.DDI.380': 'Sección condensada Estado de anulación (209-224)',
		'ISOBUS.DDI.381': 'Sección condensada Estado de anulación (225-240)',
		'ISOBUS.DDI.382': 'Sección condensada Estado de anulación (241-256)',
		'ISOBUS.DDI.383': 'Dirección aparente del viento',
		'ISOBUS.DDI.384': 'Velocidad aparente del viento',
		'ISOBUS.DDI.385': 'MSL Presión atmosférica',
		'ISOBUS.DDI.386': 'Presión atmosférica real',
		'ISOBUS.DDI.387': 'Revoluciones totales en revoluciones fraccionarias',
		'ISOBUS.DDI.388': 'Revoluciones totales en revoluciones completas',
		'ISOBUS.DDI.389': 'Revoluciones de consigna especificadas como recuento por tiempo ',
		'ISOBUS.DDI.39': 'Volumen mínimo por tiempo de aplicación',
		'ISOBUS.DDI.390': 'Revoluciones reales por tiempo',
		'ISOBUS.DDI.391': 'Revoluciones por tiempo por defecto',
		'ISOBUS.DDI.392': 'Revoluciones mínimas por tiempo',
		'ISOBUS.DDI.393': 'Revoluciones máximas por tiempo',
		'ISOBUS.DDI.394': 'Contenido real del depósito de combustible',
		'ISOBUS.DDI.395': 'Contenido real del depósito de fluido de escape diésel',
		'ISOBUS.DDI.396': 'Velocidad de consigna',
		'ISOBUS.DDI.397': 'Velocidad real',
		'ISOBUS.DDI.398': 'Velocidad mínima',
		'ISOBUS.DDI.399': 'Velocidad máxima',
		'ISOBUS.DDI.4': 'Volumen mínimo por área de tasa de aplicación',
		'ISOBUS.DDI.40': 'Volumen máximo por área de tasa de aplicación',
		'ISOBUS.DDI.400': 'Fuente de velocidad',
		'ISOBUS.DDI.401': 'Aplicación real de nitrógeno',
		'ISOBUS.DDI.402': 'Aplicación real de amonio',
		'ISOBUS.DDI.403': 'Aplicación real del fósforo',
		'ISOBUS.DDI.404': 'Aplicación real de potasio',
		'ISOBUS.DDI.405': 'Aplicación real de materia seca',
		'ISOBUS.DDI.406': 'Contenido real de proteínas',
		'ISOBUS.DDI.407': 'Contenido medio en proteínas',
		'ISOBUS.DDI.408': 'Contaminación media de los cultivos',
		'ISOBUS.DDI.409': 'Consumo total de líquido de escape diésel',
		'ISOBUS.DDI.41': 'Valor de consigna de masa por tiempo de tasa de aplicación',
		'ISOBUS.DDI.410': 'Líquido de escape diesel Cons. por tiempo',
		'ISOBUS.DDI.411': 'Líquido de escape diésel Cons. por área',
		'ISOBUS.DDI.412': 'Consumo de fluido de escape diésel total',
		'ISOBUS.DDI.413': 'Consumo medio de escape diésel total',
		'ISOBUS.DDI.414': 'Consumo medio de escape diésel total',
		'ISOBUS.DDI.415': 'Porcentaje real de semillas',
		'ISOBUS.DDI.416': 'Porcentaje medio de singulación de semillas',
		'ISOBUS.DDI.417': 'Porcentaje real de omisión de semillas',
		'ISOBUS.DDI.418': 'Porcentaje medio de omisión de semillas',
		'ISOBUS.DDI.419': 'Porcentaje múltiple de semilla real',
		'ISOBUS.DDI.42': 'Masa real por tiempo de tasa de aplicación',
		'ISOBUS.DDI.420': 'Porcentaje múltiple medio de semillas ',
		'ISOBUS.DDI.421': 'Desviación real de la distancia entre semillas',
		'ISOBUS.DDI.422': 'Desviación real de la distancia entre semillas',
		'ISOBUS.DDI.423': 'Coeficiente real de variación de la distancia entre semillas en porcentaje',
		'ISOBUS.DDI.424': 'Coeficiente real de variación de la distancia entre semillas en porcentaje',
		'ISOBUS.DDI.425': 'Desviación máxima permitida de la distancia entre semillas',
		'ISOBUS.DDI.426': 'Fuerza aerodinámica consigna',
		'ISOBUS.DDI.427': 'Fuerza aerodinámica real',
		'ISOBUS.DDI.428': 'Masa total cargada',
		'ISOBUS.DDI.429': 'Masa total sin carga',
		'ISOBUS.DDI.43': 'Tasa de aplicación de masa por tiempo por defecto',
		'ISOBUS.DDI.430': 'Masa total cargada',
		'ISOBUS.DDI.431': 'Masa total descargada',
		'ISOBUS.DDI.432': 'Tasa de aplicación de nitrógeno consigna',
		'ISOBUS.DDI.433': 'Tasa real de aplicación de nitrógeno',
		'ISOBUS.DDI.434': 'Dosis mínima de aplicación de nitrógeno',
		'ISOBUS.DDI.435': 'Dosis máxima de aplicación de nitrógeno',
		'ISOBUS.DDI.436': 'Tasa de aplicación de amonio consigna',
		'ISOBUS.DDI.437': 'Dosis real de aplicación de amonio',
		'ISOBUS.DDI.438': 'Dosis mínima de aplicación de amonio',
		'ISOBUS.DDI.439': 'Dosis máxima de aplicación de amonio',
		'ISOBUS.DDI.44': 'Masa mínima por dosis de aplicación',
		'ISOBUS.DDI.440': 'Tasa de aplicación de fósforo',
		'ISOBUS.DDI.441': 'Dosis real de aplicación de fósforo',
		'ISOBUS.DDI.442': 'Dosis mínima de aplicación de fósforo',
		'ISOBUS.DDI.443': 'Dosis máxima de aplicación de fósforo',
		'ISOBUS.DDI.444': 'Dosis nominal de aplicación de potasio',
		'ISOBUS.DDI.445': 'Dosis real de aplicación de potasio',
		'ISOBUS.DDI.446': 'Dosis mínima de aplicación de potasio',
		'ISOBUS.DDI.447': 'Dosis máxima de aplicación de potasio',
		'ISOBUS.DDI.448': 'Tasa de aplicación de materia seca',
		'ISOBUS.DDI.449': 'Tasa de aplicación real de materia seca',
		'ISOBUS.DDI.45': 'Masa máxima por tiempo de aplicación',
		'ISOBUS.DDI.450': 'Dosis mínima de aplicación de materia seca',
		'ISOBUS.DDI.451': 'Dosis máxima de aplicación de materia seca',
		'ISOBUS.DDI.452': 'Volumen total cargado',
		'ISOBUS.DDI.453': 'Volumen total descargado',
		'ISOBUS.DDI.454': 'Volumen total cargado',
		'ISOBUS.DDI.455': 'Volumen total descargado ',
		'ISOBUS.DDI.456': 'Último volumen cargado',
		'ISOBUS.DDI.457': 'Último volumen descargado',
		'ISOBUS.DDI.458': 'Recuento total cargado',
		'ISOBUS.DDI.459': ' Recuento total sin carga',
		'ISOBUS.DDI.46': 'Recuento consigna por tiempo de tasa de aplicación',
		'ISOBUS.DDI.460': 'Recuento total del total cargado',
		'ISOBUS.DDI.461': 'Recuento total del total descargado',
		'ISOBUS.DDI.462': 'Último recuento cargado',
		'ISOBUS.DDI.463': 'Último recuento descargado',
		'ISOBUS.DDI.464': 'Contador de arrastre',
		'ISOBUS.DDI.465': 'Contador de transportes total',
		'ISOBUS.DDI.466': 'Ángulo relativo real del conector',
		'ISOBUS.DDI.467': 'Contenido de porcentaje real',
		'ISOBUS.DDI.468': 'Suelo Nieve/Cond. helada',
		'ISOBUS.DDI.469': 'Condición estimada del agua del suelo',
		'ISOBUS.DDI.47': 'Recuento real de tiempo de asa de aplicación',
		'ISOBUS.DDI.470': 'Compactación del suelo',
		'ISOBUS.DDI.472': 'Longitud de corte consigna',
		'ISOBUS.DDI.473': 'Longitud mínima de corte',
		'ISOBUS.DDI.474': 'Longitud máxima de corte',
		'ISOBUS.DDI.475': 'Punto de ajuste de presión hidráulica de la bala',
		'ISOBUS.DDI.476': 'Presión hidráulica mínima de la bala',
		'ISOBUS.DDI.477': 'Presión hidráulica máxima de la bala',
		'ISOBUS.DDI.478': 'Tamaño del copo',
		'ISOBUS.DDI.479': 'Tamaño mínimo de los copos',
		'ISOBUS.DDI.48': 'Recuento predeterminado por tiempo de tasa de aplicación',
		'ISOBUS.DDI.480': 'Tamaño máximo de la hojuela',
		'ISOBUS.DDI.481': 'Número de subbalizas consigna ',
		'ISOBUS.DDI.482': 'Ultima número de balizas de subbaliza',
		'ISOBUS.DDI.483': 'Régimen motor consigna',
		'ISOBUS.DDI.484': 'Régimen real del motor',
		'ISOBUS.DDI.485': 'Régimen mínimo del motor',
		'ISOBUS.DDI.486': 'Régimen máximo del motor',
		'ISOBUS.DDI.488': 'Nivel porcentual del depósito de fluido de escape diésel',
		'ISOBUS.DDI.489': 'Contenido máximo del depósito de fluido de escape diésel',
		'ISOBUS.DDI.49': 'Recuento mínimo por tiempo de tasa de aplicación',
		'ISOBUS.DDI.490': 'Contenido máximo del depósito de combustible',
		'ISOBUS.DDI.491': 'Nivel de porcentaje de combustible',
		'ISOBUS.DDI.492': 'Horas totales del motor',
		'ISOBUS.DDI.493': 'Horas motor total',
		'ISOBUS.DDI.494': 'ID del socio del último evento (Byte 1-4)',
		'ISOBUS.DDI.495': 'ID del socio del último evento (Byte 5-8)',
		'ISOBUS.DDI.496': 'ID del socio del último evento (Byte 9-12)',
		'ISOBUS.DDI.497': 'ID del socio del último evento (Byte 13-16)',
		'ISOBUS.DDI.498': 'Último evento Tipo de ID de socio',
		'ISOBUS.DDI.499': 'Último evento ID de socio Código ID de fabricante',
		'ISOBUS.DDI.5': 'Volumen máximo por área de tasa de aplicación',
		'ISOBUS.DDI.50': 'Recuento máximo por área de tasa de aplicación',
		'ISOBUS.DDI.500': 'Último evento ID de socio Clase de dispositivo',
		'ISOBUS.DDI.501': 'Par motor consigna',
		'ISOBUS.DDI.502': 'Par motor real',
		'ISOBUS.DDI.503': 'Par motor mínimo',
		'ISOBUS.DDI.504': 'Par motor máximo',
		'ISOBUS.DDI.505': 'Nivel de control del tranvía',
		'ISOBUS.DDI.506': 'Nivel de control del tranvía consigna ',
		'ISOBUS.DDI.507': 'Número de secuencia del tranvía',
		'ISOBUS.DDI.508': 'ID único de línea de referencia de orientación A-B',
		'ISOBUS.DDI.509': 'Número real de pista',
		'ISOBUS.DDI.51': 'Profundidad de labranza consigna',
		'ISOBUS.DDI.510': 'Número de pista a la derecha',
		'ISOBUS.DDI.511': 'Número de pista a la izquierda',
		'ISOBUS.DDI.512': 'Anchura de hilera de la línea guía',
		'ISOBUS.DDI.513': 'Desviación de la línea de orientación',
		'ISOBUS.DDI.514': 'Calidad GPS',
		'ISOBUS.DDI.515': 'Estado de control del tranvía',
		'ISOBUS.DDI.516': 'Tasa de sobredosificación de tranvía',
		'ISOBUS.DDI.517': 'Setpoint Tramline Condensed Work State 1-16',
		'ISOBUS.DDI.518': 'Estado actual de las obras condensadas del tranvía (1-16)',
		'ISOBUS.DDI.519': 'Recuento de última paca total',
		'ISOBUS.DDI.52': 'Profundidad real de labranza',
		'ISOBUS.DDI.520': 'Altura real del canopeo',
		'ISOBUS.DDI.521': 'Tipo de instalación GPS',
		'ISOBUS.DDI.522': 'Recuento total de paca de hilo',
		'ISOBUS.DDI.523': 'Recuento total de paca de malla',
		'ISOBUS.DDI.524': 'Recuento total de paca de hilo total',
		'ISOBUS.DDI.525': 'Recuento total de paca de malla total',
		'ISOBUS.DDI.526': 'Temperatura real del líquido refrigerante',
		'ISOBUS.DDI.528': 'Capacidad de la última bala',
		'ISOBUS.DDI.529': 'Punto de ajuste de ángulo del disco de labranza',
		'ISOBUS.DDI.53': 'Profundidad de labranza por defecto',
		'ISOBUS.DDI.530': 'Ángulo real del disco de labranza',
		'ISOBUS.DDI.531': 'Conservante real aplicado por masa útil',
		'ISOBUS.DDI.532': 'Conservante consigna aplicado por masa útil',
		'ISOBUS.DDI.533': 'Conservante aplicado por defecto por masa útil',
		'ISOBUS.DDI.534': 'Conservante mínimo aplicado por masa útil',
		'ISOBUS.DDI.535': 'Conservante máximo aplicado por masa útil',
		'ISOBUS.DDI.536': 'Conservante total aplicado',
		'ISOBUS.DDI.537': 'Conservante aplicado total',
		'ISOBUS.DDI.538': 'Conservante medio aplicado por masa útil',
		'ISOBUS.DDI.539': 'Volumen real del depósito de conservante',
		'ISOBUS.DDI.54': 'Profundidad mínima de labranza',
		'ISOBUS.DDI.540': 'Nivel real del depósito de conservante',
		'ISOBUS.DDI.541': 'Velocidad real de la TDF',
		'ISOBUS.DDI.542': 'Consigna velocidad TDF',
		'ISOBUS.DDI.543': 'Velocidad predeterminada de la TDF',
		'ISOBUS.DDI.544': 'Velocidad mínima de la TDF',
		'ISOBUS.DDI.545': 'Velocidad máxima de la TDF',
		'ISOBUS.DDI.546': ' Tiempo total de compromiso de corte',
		'ISOBUS.DDI.547': 'Carga consigna del émbolo de compresión de la bala',
		'ISOBUS.DDI.548': 'Carga real del émbolo de compresión de la bala',
		'ISOBUS.DDI.549': 'Última paca de compresión media de la paca de carga del émbolo',
		'ISOBUS.DDI.55': 'Profundidad máxima de labranza',
		'ISOBUS.DDI.550': 'Cubierta vegetal',
		'ISOBUS.DDI.551': 'Par real de la TDF',
		'ISOBUS.DDI.552': 'Consigna Par TDF',
		'ISOBUS.DDI.553': 'Par de la TDF por defecto',
		'ISOBUS.DDI.554': 'Par mínimo de la TDF',
		'ISOBUS.DDI.555': 'Par máximo de la TDF',
		'ISOBUS.DDI.556': 'Condiciones meteorológicas actuales',
		'ISOBUS.DDI.557': 'Corriente eléctrica consigna',
		'ISOBUS.DDI.558': 'Corriente eléctrica real',
		'ISOBUS.DDI.559': 'Corriente eléctrica mínima',
		'ISOBUS.DDI.56': 'Profundidad de siembra consigna',
		'ISOBUS.DDI.560': 'Corriente eléctrica máxima',
		'ISOBUS.DDI.561': 'Corriente eléctrica por defecto',
		'ISOBUS.DDI.562': 'Tensión consigna',
		'ISOBUS.DDI.563': 'Tensión por defecto',
		'ISOBUS.DDI.564': 'Tensión real',
		'ISOBUS.DDI.565': 'Tensión mínima',
		'ISOBUS.DDI.566': 'Tensión máxima',
		'ISOBUS.DDI.567': 'Resistencia eléctrica real',
		'ISOBUS.DDI.568': 'Potencia eléctrica consigna',
		'ISOBUS.DDI.569': 'Potencia eléctrica real',
		'ISOBUS.DDI.57': 'Profundidad real de siembra',
		'ISOBUS.DDI.570': 'Energía eléctrica por defecto',
		'ISOBUS.DDI.571': 'Potencia eléctrica máxima',
		'ISOBUS.DDI.572': 'Potencia eléctrica mínima',
		'ISOBUS.DDI.573': 'Energía eléctrica total',
		'ISOBUS.DDI.574': 'Tasa consigna de aplicación de energía eléctrica por superficie',
		'ISOBUS.DDI.575': 'Tasa real de aplicación de energía eléctrica por superficie',
		'ISOBUS.DDI.576': 'Tasa máxima de aplicación de energía eléctrica por superficie',
		'ISOBUS.DDI.577': 'Tasa mínima de aplicación de energía eléctrica por superficie',
		'ISOBUS.DDI.578': 'Temperatura de consigna',
		'ISOBUS.DDI.579': 'Temperatura real',
		'ISOBUS.DDI.58': 'Profundidad de siembra por defecto',
		'ISOBUS.DDI.580': 'Temperatura mínima',
		'ISOBUS.DDI.581': 'Temperatura máxima',
		'ISOBUS.DDI.582': 'Temperatura por defecto',
		'ISOBUS.DDI.583': 'Frecuencia de consigna',
		'ISOBUS.DDI.584': 'Frecuencia real',
		'ISOBUS.DDI.585': 'Frecuencia mínima',
		'ISOBUS.DDI.586': 'Frecuencia máxima',
		'ISOBUS.DDI.587': 'Precipitaciones anteriores',
		'ISOBUS.DDI.588': 'Volumen de consigna por área de tasa de aplicación',
		'ISOBUS.DDI.589': 'Volumen real por área de tasa de aplicación',
		'ISOBUS.DDI.59': 'Profundidad mínima de siembra',
		'ISOBUS.DDI.590': 'Volumen mínimo por área de tasa de aplicación',
		'ISOBUS.DDI.591': 'Volumen máximo por área de tasa de aplicación',
		'ISOBUS.DDI.592': 'Volume por defecto por area de tasa de application',
		'ISOBUS.DDI.593': 'Tipo de tracción',
		'ISOBUS.DDI.594': 'Tipo de dirección',
		'ISOBUS.DDI.595': 'Modo de máquina',
		'ISOBUS.DDI.596': 'Estado de cobertura de la zona de carga',
		'ISOBUS.DDI.597': 'Distancia total',
		'ISOBUS.DDI.598': 'Distancia total',
		'ISOBUS.DDI.599': 'Distancia total del campo',
		'ISOBUS.DDI.6': 'Valor de consigna de masa por area de tasa de application',
		'ISOBUS.DDI.60': 'Profundidad máxima de siembra',
		'ISOBUS.DDI.600': 'Campo de distancia total ',
		'ISOBUS.DDI.601': 'Distancia total de la calle',
		'ISOBUS.DDI.602': 'Distancia total de la calle',
		'ISOBUS.DDI.603': 'Estado actual de las obras condensadas del tranvía (17-32)',
		'ISOBUS.DDI.604': 'Estado actual de las obras condensadas del tranvía (33-48)',
		'ISOBUS.DDI.605': 'Estado actual del trabajo condensado del tranvía (49-64)',
		'ISOBUS.DDI.606': 'Estado actual de las obras condensadas del tranvía (65-80) ',
		'ISOBUS.DDI.607': 'Estado actual de las obras condensadas del tranvía  (81-96) ',
		'ISOBUS.DDI.608': 'Estado actual de las obras condensadas del tranvía (97-112) ',
		'ISOBUS.DDI.609': 'Estado actual de las obras condensadas del tranvía (113-128)',
		'ISOBUS.DDI.61': 'Altura de Trabajo Nominal',
		'ISOBUS.DDI.610': 'Estado actual de las obras condensadas del tranvía (129-144)',
		'ISOBUS.DDI.611': 'Estado actual del trabajo condensado del tranvía (145-160)',
		'ISOBUS.DDI.612': 'Estado actual de las obras condensadas del tranvía (161-176)',
		'ISOBUS.DDI.613': 'Estado actual de las obras condensadas del tranvía (177-192)',
		'ISOBUS.DDI.614': 'Estado actual de las obras condensadas del tranvía (193-208)',
		'ISOBUS.DDI.615': 'Estado actual do trabalho condensado do Eléctrico (209-224)',
		'ISOBUS.DDI.616': 'Estado actual do trabalho condensado do Eléctrico (225-240)',
		'ISOBUS.DDI.617': 'Estado actual de las obras condensadas del tranvía (241-256)',
		'ISOBUS.DDI.618': 'Consigna Tramino de Estado de trabajo condensado (17-32) ',
		'ISOBUS.DDI.619': 'Consigna del tranvía de estado de trabajo condensado  (33-48) ',
		'ISOBUS.DDI.62': 'Altura Real de Trabajo',
		'ISOBUS.DDI.620': 'Consigna Tranvía Estado de trabajo condensado (49-64) ',
		'ISOBUS.DDI.621': 'Setpoint Tramline Condensed Work State (65-80)',
		'ISOBUS.DDI.622': 'Estado de trabajo condensado del tranvía de consigna (81-96)',
		'ISOBUS.DDI.623': 'Estado de trabajo condensado del tranvía de consigna  (97-112)',
		'ISOBUS.DDI.624': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (113-128)',
		'ISOBUS.DDI.625': 'Estado de trabajo condensado del tranvía de consigna (129-144)',
		'ISOBUS.DDI.626': 'Estado de trabajo condensado del tranvía de consigna  (145-160)',
		'ISOBUS.DDI.627': 'Estado de trabajo condensado del tranvía de consigna (161-176)',
		'ISOBUS.DDI.628': 'Estado de trabajo condensado del tranvía de consigna (177-192)',
		'ISOBUS.DDI.629': 'Estado de trabajo condensado del tranvía de consigna (193-208)',
		'ISOBUS.DDI.63': 'Altura de trabajo por defecto',
		'ISOBUS.DDI.630': 'Estado de trabajo condensado del tranvía de consigna (209-224)',
		'ISOBUS.DDI.631': 'Estado de trabajo condensado del tranvía de consigna  (225-240)',
		'ISOBUS.DDI.632': 'Estado de trabajo condensado del tranvía de consigna (241-256)',
		'ISOBUS.DDI.634': 'Volumen real por distancia de tasa de aplicación',
		'ISOBUS.DDI.635': 'Volumen por defecto por distancia de tasa de aplicación',
		'ISOBUS.DDI.636': 'Volumen mínimo por distancia de tasa de aplicación',
		'ISOBUS.DDI.637': 'Volumen máximo por distancia de tasa de aplicación',
		'ISOBUS.DDI.638': 'Punto de ajuste de la presión de los neumáticos',
		'ISOBUS.DDI.639': 'Presión real de los neumáticos',
		'ISOBUS.DDI.64': 'Altura mínima de trabajo',
		'ISOBUS.DDI.640': 'Presión de los neumáticos por defecto',
		'ISOBUS.DDI.641': 'Presión mínima de los neumáticos',
		'ISOBUS.DDI.642': 'Presión máxima de los neumáticos',
		'ISOBUS.DDI.643': 'Temperatura real de los neumáticos',
		'ISOBUS.DDI.65': 'Altura máxima de trabajo',
		'ISOBUS.DDI.66': 'Ancho de trabajo consigna',
		'ISOBUS.DDI.67': 'Anchura de trabajo real',
		'ISOBUS.DDI.68': 'Anchura de trabajo por defecto',
		'ISOBUS.DDI.69': 'Anchura mínima de trabajo',
		'ISOBUS.DDI.7': 'Masa real por tasa de aplicación',
		'ISOBUS.DDI.70': 'Anchura máxima de trabajo',
		'ISOBUS.DDI.71': 'Contenido de volumen de consigna',
		'ISOBUS.DDI.72': 'Contenido de volumen real',
		'ISOBUS.DDI.73': 'Contenido de volumen máximo',
		'ISOBUS.DDI.74': 'Contenido de masa de consigna',
		'ISOBUS.DDI.75': 'Contenido real en masa',
		'ISOBUS.DDI.76': 'Máximo contenido de masa',
		'ISOBUS.DDI.77': 'Contenido del recuento consigna',
		'ISOBUS.DDI.78': 'Recuento de contenido real',
		'ISOBUS.DDI.79': 'Contenido máximo del recuento',
		'ISOBUS.DDI.8': 'Tasa de aplicación de masa por área por defecto',
		'ISOBUS.DDI.80': 'Volumen total de aplicación',
		'ISOBUS.DDI.81': 'Masa total de aplicación',
		'ISOBUS.DDI.82': 'Recuento de total de aplicación',
		'ISOBUS.DDI.83': 'Volumen por rendimiento de área',
		'ISOBUS.DDI.84': 'Masa por rendimiento de área',
		'ISOBUS.DDI.85': 'Recuento por rendimiento de área',
		'ISOBUS.DDI.86': 'Volumen por rendimiento de tiempo',
		'ISOBUS.DDI.87': 'Masa por rendimiento de tiempo',
		'ISOBUS.DDI.88': 'Recuento de rendimiento de tiempo',
		'ISOBUS.DDI.89': 'Rendimiento en volumen total',
		'ISOBUS.DDI.9': 'Masa mínima por superficie por dosis de aplicación',
		'ISOBUS.DDI.90': 'Rendimiento en masa total',
		'ISOBUS.DDI.91': 'Recuento de rendimiento total',
		'ISOBUS.DDI.92': 'Pérdida de cultivos en volumen por área ',
		'ISOBUS.DDI.93': 'Pérdida de cultivos en masa por área ',
		'ISOBUS.DDI.94': 'Recuento de pérdida de cultivos por área ',
		'ISOBUS.DDI.95': 'Pérdida de cultivo en volumen por tiempo',
		'ISOBUS.DDI.96': 'Pérdida de cultivo en masa por tiempo',
		'ISOBUS.DDI.97': 'Pérdida de cultivo por tiempo',
		'ISOBUS.DDI.98': 'Porcentaje de pérdida de cosechas',
		'ISOBUS.DDI.99': 'Humedad de los cultivos',
		'ISOBUS.DEVICE_CLASS.0': 'Sin especificar',
		'ISOBUS.DEVICE_CLASS.1': 'Tractor',
		'ISOBUS.DEVICE_CLASS.10': 'Riego',
		'ISOBUS.DEVICE_CLASS.11': 'Transporte/remolque',
		'ISOBUS.DEVICE_CLASS.12': 'Explotaciones agrícolas',
		'ISOBUS.DEVICE_CLASS.13': 'Dispositivos auxiliares motorizados',
		'ISOBUS.DEVICE_CLASS.14': 'Cultivos especiales',
		'ISOBUS.DEVICE_CLASS.15': 'Trabajos de tierra',
		'ISOBUS.DEVICE_CLASS.16': 'Arrastrador',
		'ISOBUS.DEVICE_CLASS.17': 'Sistemas de sensores',
		'ISOBUS.DEVICE_CLASS.18': '-',
		'ISOBUS.DEVICE_CLASS.19': 'Madereros',
		'ISOBUS.DEVICE_CLASS.2': 'Labranza',
		'ISOBUS.DEVICE_CLASS.20': 'Transitarios',
		'ISOBUS.DEVICE_CLASS.21': 'Cargadores de madera',
		'ISOBUS.DEVICE_CLASS.22': 'Máquinas para el tratamiento de la madera',
		'ISOBUS.DEVICE_CLASS.23': 'Trituradoras',
		'ISOBUS.DEVICE_CLASS.24': 'Vehículos utilitarios',
		'ISOBUS.DEVICE_CLASS.25': 'Aplicadores de estiércol',
		'ISOBUS.DEVICE_CLASS.26': 'Alimentadoras/ Mixers',
		'ISOBUS.DEVICE_CLASS.27': 'Desmalezadoras',
		'ISOBUS.DEVICE_CLASS.3': 'Labranza secundaria',
		'ISOBUS.DEVICE_CLASS.4': 'Sembradoras',
		'ISOBUS.DEVICE_CLASS.5': 'Fertilizantes',
		'ISOBUS.DEVICE_CLASS.6': 'Pulverizadores',
		'ISOBUS.DEVICE_CLASS.7': 'Cosechadores',
		'ISOBUS.DEVICE_CLASS.8': 'Cosechadoras de raíces',
		'ISOBUS.DEVICE_CLASS.9': 'Forraje',
		"ISOBUS.ELEMENT_NUMBER": "Número de elemento",
		'JOB.ARCHIVE.QUESTION': '¿De verdad desea archivar este trabajo?',
		'JOB.ARCHIVE.SUCCESS': 'El trabajo se archivará',
		'JOB.CAN_NOT_BE_DISPLAYED_COMPLETELY': 'El trabajo no puede visualizarse completamente. Es posible que la información anterior no esté actualizada y se vuelva a calcular.',
		'JOB.CURRENT_STATUS': 'Situación actual',
		'JOB.DELETE.QUESTION': '¿De verdad quieres borrar este trabajo?',
		'JOB.DELETE.SUCCESS': 'El trabajo va a ser eliminado',
		'JOB.DETAILS': 'Detalles del trabajo',
		'JOB.DRIVER_IMPLEMENT': 'Eliminar o cambiar el controlador/implemento.',
		'JOB.EDIT': 'Editar trabajo',
		'JOB.REGENERATE': 'Regenerar trabajo',
		'JOB.REGENERATE.DRIVER': 'Actualizar los datos del conductor',
		'JOB.REGENERATE.FIELDS': 'Actualizar datos de los campos',
		'JOB.REGENERATE.IMPLEMENT': 'Actualizar datos del implemento',
		'JOB.REGENERATE.INTRO': 'Si los datos de facturación de máquinas, aperos o conductores han cambiado, también pueden actualizarse.',
		'JOB.REGENERATE.LOCATIONS': 'Actualizar datos de localización',
		'JOB.REGENERATE.MACHINE': 'Actualizar los datos de la máquina',
		'JOB.REGENERATE.QUESTION': '¿Qué datos deben actualizarse?',
		'JOB.REGENERATE.SUCCESS': 'Job va a ser regenerado',
		'JOB.SPLIT': 'Trabajo dividido',
		'JOB.SPLIT.ADD_SPLIT_TIME': 'Añadir tiempo parcial',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO': 'Para ajustes con precisión de segundos, el control deslizante de tiempo también puede manejarse con los botones de flecha.',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO2': 'Añade tiempo(s) para dividir el trabajo.',
		'JOB.SPLIT.NO_CHANGE': 'Ningún cambio en el trabajo',
		'JOB.SPLIT.NO_SPLITS': 'No hay hora(s) seleccionada(s) para dividir.',
		'JOB.UPDATE': 'Actualizar trabajos',
		'JOB.WAITING_TIME_UNTIL_READY': 'Dependiendo del estado actual, el trabajo puede tardar unos minutos en mostrarse por completo.',
		'JOBS': 'Trabajos ',
		'JOBS.ALL': 'Todos los trabajos',
		'JOBS.ARCHIVE.PARTIAL': 'Algunos trabajos se archivan.',
		'JOBS.ARCHIVE.QUESTION': '¿Realmente quieres archivar los trabajos seleccionados?',
		'JOBS.ARCHIVE.SUCCESS': 'Los trabajos se archivarán',
		'JOBS.CREATE_TASK': 'Crear tarea',
		'JOBS.DELETE.QUESTION': '¿Realmente desea eliminar los trabajos seleccionados? Todos los datos de los trabajos se eliminarán de forma irreversible.',
		'JOBS.DELETE.SUCCESS': 'Los trabajos serán eliminados',
		'JOBS.DELETED.FAILURE': 'Algunos de los trabajos no se han podido eliminar',
		'JOBS.EDIT': 'Editar trabajos',
		'JOBS.EDIT.SUCCESS': 'Los trabajos se van a editar',
		'JOBS.IN_TASK': 'Trabajos en tareas',
		'JOBS.MERGE.SUCCESS': 'Los puestos de trabajo se van a fusionar',
		'JOBS.MERGING': 'Fusionar trabajos',
		'JOBS.NO': 'No hay trabajo',
		'JOBS.NOT_SELECTED': 'Ningún trabajo seleccionado',
		'JOBS.REGENERATE': 'Regenerar puestos de trabajo',
		'JOBS.REGENERATE.SUCCESS': 'Se regenerarán los trabajos',
		'JOBS.SELECTED': 'Trabajos seleccionados',
		'JOBS.TASK_CREATED': 'Tarea creada con éxito',
		'JOBS.UPDATE.SUCCESS': 'Se van a actualizar los puestos de trabajo',
		'JOBS.WITHOUT_TASK': 'Trabajos sin tarea',
		'JOBS.WITH_TASK': 'Trabajos en tarea',
		'KILOMETERS': 'Kilómetros',
		'LANGUAGE': 'Idioma',
		'LANGUAGE.ADD': 'Añadir idioma',
		'LANGUAGE.CODE': 'Código de idioma',
		'LANGUAGE.DEFAULT': 'Idioma por defecto',
		'LASTNAME': 'Apellido',
		'LAST_ONLINE': 'Última vez en línea',
		'LAST_UPDATED': 'Última actualización',
		'LATITUDE': 'Latitud',
		'LOAD.MORE': 'Cargar más',
		'LOADS': 'Loads',
		'LOCATION': 'Ubicación',
		'LOCATION.ADD': 'Añadir ubicación',
		'LOCATION.ADD.SUCCESS': 'Ubicación añadida correctamente',
		'LOCATION.DEACTIVATE.QUESTION': '¿Realmente quiere desactivar la localización?',
		'LOCATION.DEACTIVATE.SUCCESS': 'Ubicación desactivada correctamente',
		'LOCATION.DELETE.QUESTION': '¿Realmente deseas eliminar la ubicación?',
		'LOCATION.DELETE.SUCCESS': 'Ubicación eliminada correctamente',
		'LOCATION.DETAILS': 'Detalles de la ubicación',
		'LOCATION.DRAW.START': '¡Marcar ubicación en el mapa ahora!',
		'LOCATION.EDIT.SUCCESS': 'Ubicación editada correctamente',
		'LOCATIONS': 'Ubicaciones',
		'LOCATIONS.ALL': 'Todos los lugares',
		'LOCATIONS.DEACTIVATE.FAILURE': 'Algunas de las ubicaciones no pudieron desactivarse.',
		'LOCATIONS.DEACTIVATE.QUESTION': '¿Realmente quiere desactivar las localizaciones?',
		'LOCATIONS.DEACTIVATE.SUCCESS': 'Ubicaciones desactivadas correctamente',
		'LOCATIONS.DELETE.FAILURE': 'Algunas de las ubicaciones no se han podido borrar',
		'LOCATIONS.DELETE.QUESTION': '¿Realmente desea eliminar las ubicaciones seleccionadas?',
		'LOCATIONS.DELETE.SUCCESS': 'Ubicaciones eliminadas correctamente',
		'LOCATIONS.NO': 'Sin ubicaciones',
		'LOCATIONS.NOT_SELECTED': 'No hay lugares seleccionados',
		'LOCATIONS.REACTIVATE.FAILURE': 'Some of the locations could not be reactivated.',
		'LOCATIONS.REACTIVATE.QUESTION': '¿Realmente desea reactivar las ubicaciones seleccionadas?',
		'LOCATIONS.REACTIVATE.SUCCESS': 'Locations reactivated successfully',
		'LOCATIONS.SELECTED': 'Lugares seleccionados',
		'LOG': 'Registro de mensajes',
		'LOGIN': 'Acceder',
		'LOGIN.NOT_UNLOCKED_YET': '¿Aún no está desbloqueado?',
		'LOGIN.NO_ACCOUNT_YET': '¿Aún no tiene cuenta?',
		'LOGIN.PASSWORD_FORGOTTEN': '¿Ha olvidado su contraseña?',
		'LOGIN.REGISTER': 'Regístrese ',
		'LOGIN.REMEMBER_PASSWORD': 'Recordar contraseña',
		'LOGIN.UNLOCK': 'Desbloquear',
		'LOG_OUT': 'Cerrar sesión',
		'LONGITUDE': 'Longitude',
		'LOST_PASSWORD.CHANGE_PASSWORD': 'Cambiar contraseña',
		'LOST_PASSWORD.ENTER_ACTIVATION': 'Introduzca el código de activación que ha recibido por correo electrónico.',
		'LOST_PASSWORD.ENTER_EMAIL_HERE': 'Introduzca aquí su dirección de correo electrónico.',
		'LOST_PASSWORD.ENTER_VALID_EMAIL': 'Introduzca una dirección de correo electrónico válida.',
		'MAC': 'MAC',
		'MACHINE': 'Máquina',
		'MACHINE.ADD': 'Añadir máquina',
		'MACHINE.ADD.SUCCESS': 'Máquina añadida correctamente',
		'MACHINE.DELETE.QUESTION': '¿De verdad quieres borrar la máquina?',
		'MACHINE.DELETE.SUCCESS': 'Máquina eliminada con éxito',
		'MACHINE.DETAILS': 'Detalles de la máquina',
		'MACHINE.EDIT': 'Editar máquina',
		'MACHINE.EDIT.SUCCESS': 'Máquina editada con éxito',
		'MACHINE.INTERVAL.ADD': 'Añadir intervalo de máquina',
		'MACHINE.LIVE_STATUS': 'Estado de la máquina',
		'MACHINE.NO': 'Ninguna máquina',
		'MACHINE.RELOAD_POSITIONS': 'Recargar posiciones de la máquina',
		'MACHINE.STATUS': 'Estado de la máquina',
		'MACHINES': 'Máquinas',
		'MACHINES.ALL': 'Todas las máquinas',
		'MACHINES.DEACTIVATE.FAILURE': 'Some of the machines could not be deactivated.',
		'MACHINES.DEACTIVATE.QUESTION': '¿Realmente desea desactivar las máquinas seleccionadas?',
		'MACHINES.DEACTIVATE.SUCCESS': 'Máquinas desactivadas correctamente',
		'MACHINES.DELETE.FAILURE': 'Algunas máquinas no se han podido borrar.',
		'MACHINES.DELETE.QUESTION': '¿Realmente desea eliminar las máquinas seleccionadas?',
		'MACHINES.DELETE.SUCCESS': 'Máquinas eliminadas correctamente',
		'MACHINES.MANAGEMENT': 'Gestión de máquinas',
		'MACHINES.NO': 'Sin máquinas',
		'MACHINES.NOT_SELECTED': 'Ninguna máquina seleccionada',
		'MACHINES.NO_LICENSE.WARNING': 'La máquina no tiene licencia adjunta. Sin licencia no se registrará ningún dato.',
		'MACHINES.REACTIVATE.FAILURE': 'Algunas máquinas no pudieron reactivarse.',
		'MACHINES.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected machines?',
		'MACHINES.REACTIVATE.SUCCESS': 'Máquinas reactivadas con éxito',
		'MACHINES.SELECTED': 'Máquinas seleccionadas',
		'MACHINE_COMBINATION': 'Machine combination',
		'MACHINE_IMPLEMENT': 'Máquina/Implemento',
		'MAC_DEVICES': 'Dispositivos conectados a una máquina',
		'MAINTENANCE': 'Mantenimiento',
		'MAINTENANCE.AMOUNT': 'Importe de mantenimiento',
		'MAINTENANCE.PERIOD': 'Período de mantenimiento',
		'MAKE': 'Fabricante',
		'MANURE': 'Abono',
		'MANURE.TYPE': 'Tipo de abono',
		'MAP': 'Mapa',
		'MAP.SECTION': 'Sección de mapas',
		'MAP.SECTION.CHANGE': 'Cambiar sección de mapas',
		'MARKER.ADD': 'Añadir nuevo marcador',
		'MARKER.EDIT.BORDERS': 'Editar fronteras',
		'MARKER.ENTRANCE': 'Entrada',
		'MARKER.EXIT': 'Salida',
		'MARKER.INFO': 'Información',
		'MARKER.WARN': 'Advertir',
		'MAX': 'Máximo',
		'MAX_VALUE': 'Valor máximo',
		'MERGE': 'Fusión',
		'MESSAGES.NO': 'Sin mensajes',
		'MILEAGE': 'Kilometraje',
		'MILEAGE.INVALID': 'Kilometraje no válido',
		'MIN': 'Mínimo',
		'MIN_VALUE': 'Valor mínimo',
		'MOBILE': 'Móvil',
		'MODE.SWITCH': 'Cambiar de modo',
		'MODEL': 'Modelo',
		'MYPROFILE': 'Mi perfil',
		'MYPROFILE.BASIC_DATA': 'Datos básicos',
		'MYPROFILE.BASIC_DATA.EDIT.SUCCESS': 'Tus datos básicos han sido modificados',
		'NAME': 'Nombre',
		'NAV.ACTIVITIES': 'Actividades',
		'NAV.ADMIN': 'Administrador',
		'NAV.ADMIN.DASHBOARD': 'Panel de datos',
		'NAV.ADMIN.INFO_VIEW': 'Admin Info',
		'NAV.ADMIN.JOB_IMPORT_VIEW': 'Job import',
		'NAV.ADMIN.JOB_VIEW': 'Vista del trabajo',
		'NAV.ADMIN.USERS': 'Gestión de usuarios',
		'NAV.CUSTOMERS': 'Clientes',
		'NAV.DASHBOARD': 'Panel de datos',
		'NAV.DATA_PREPARATION': 'Preparación de datos',
		'NAV.EMPLOYEES': 'Empleados',
		'NAV.ENTERPRISE': 'Empresa',
		'NAV.FIELDS': 'Campos',
		'NAV.FILE_TRANSFER': 'Transferencia de Archivos',
		'NAV.HARDWARE': 'Hardware',
		'NAV.HARDWARE_SETUP': 'Configuración del hardware',
		'NAV.IMPLEMENTS': 'Implementos',
		'NAV.LOCATIONS': 'Ubicaciones',
		'NAV.MACHINES': 'Máquinas',
		'NAV.MY_SECTION': 'Mi sección',
		'NAV.PATH_PLANNINGS': 'Path planning',
		'NAV.RETAILER': 'Minorista',
		'NAV.SETTINGS': 'Ajustes',
		'NAV.SETTINGS.ADAPTER': 'Módulo',
		'NAV.SETTINGS.GENERAL': 'Empresa',
		'NAV.SETTINGS.PARTNER': 'Socio',
		'NAV.STATISTIC': 'Estadísticas',
		'NAV.TECH': 'TECH',
		'NAV.TRANSLATION.EDIT': 'Traducción',
		'NAV.TRANSLATION_MANAGEMENT': 'Gestión de traducciones',
		'NETWORK.ACCESS_TECHNOLOGY': 'Tecnología de acceso',
		'NETWORK.OPERATOR': 'Operador',
		'NEXT': 'Siguiente',
		'NO': 'No',
		'NONE': 'Ninguno',
		'NOTICE': 'Aviso',
		'NON_PRODUCTIVE_TIME': 'Tiempo no productivo',
		'NON_PRODUCTIVE_TIMES': 'Tiempos no productivos',
		'NON_PRODUCTIVE_TIMES.SEPARATOR': 'Separator for non productive time computation',
		'NOT_READ': 'No se ha podido leer.',
		'NO_DATA': 'Sin datos',
		'ONLY_ON': 'Sólo en',
		'OPACITY': 'Opacidad',
		'OPERATING_HOURS': 'Horas de funcionamiento',
		'OPERATING_HOURS.INVALID': 'Horario de funcionamiento no válido',
		'OPERATION': 'Operación',
		'OPERATION.NOT_SELECTED': 'Ninguna operación en el campo seleccionado',
		'OPERATION.SELECT': 'Seleccionar operación',
		'OPERATIONS': 'Operaciones',
		'OPERATIONS.ARRIVAL': 'Llegada',
		'OPERATIONS.CUSTOMER': 'Operaciones para el cliente',
		'OPERATIONS.FIELD': 'Operaciones sobre el terreno',
		'OPERATIONS.FIELDS': 'Operaciones en campos',
		'OPERATIONS.FIELD_TIME': 'Tiempo en el campo',
		'OPERATIONS.GEOMETRY': 'Geometría',
		'OPERATIONS.LOCATION': 'Operaciones in situ',
		'OPERATIONS.LOCATIONS': 'Operaciones en emplazamientos',
		'OPERATIONS.NO': 'Ninguna operación',
		'OPERATIONS.PREPARATION': 'Preparación',
		'OVERRIDE.NO': 'Sin anulación',
		'PAGE': 'Page',
		'PAGE.OF': 'of',
		'PAGINATION.PER_PAGE': 'Por página',
		'PAGINATION.TOTAL': 'total',
		'PAGINATOR.FIRST_PAGE': 'Primera página',
		'PAGINATOR.ITEMS_PER_PAGE': 'Artículos por página',
		'PAGINATOR.LAST_PAGE': 'Última página',
		'PAGINATOR.NEXT_PAGE': 'Página siguiente',
		'PAGINATOR.OF': 'de',
		'PAGINATOR.PREVIOUS_PAGE': 'Página anterior',
		'PARTNER_CONNECTION': 'Conexión de socios',
		'PARTNER_CONNECTION.DOES_NOT_EXPIRE': 'No caduca',
		'PARTNER_CONNECTION.EXPIRES_ON': 'Caduca el',
		'PASSWORD': 'Contraseña',
		'PASSWORD.CHANGE': 'Cambiar contraseña',
		'PASSWORD.CHANGE.ACTIVATE': 'Contraseña actual',
		'PASSWORD.CHANGE.SUCCESS': 'Contraseña modificada correctamente',
		'PASSWORD.CONFIRM': 'Confirmar nueva contraseña',
		'PASSWORD.LENGTH.REQUIRED': 'La contraseña debe tener al menos 6 caracteres',
		'PASSWORD.NEW_PASSWORD': 'Nueva contraseña',
		'PASSWORD.NO_MATCH': 'Confirmación de contraseña incorrecta',
		'PATH_PLANNING.ADD': 'Plan path',
		'PATH_PLANNING.ADD.SUCCESS': 'Planned path successfully added',
		'PATH_PLANNING.ANGLE': 'Angle',
		'PATH_PLANNING.ANGLE.LONGEST_SIDE': 'Longest side',
		'PATH_PLANNING.ANGLE.OPTIMAL': 'Optimal',
		'PATH_PLANNING.ANGLE.WORKING': 'Working angle',
		'PATH_PLANNING.AREA.COVERED': 'Covered area',
		'PATH_PLANNING.AREA.OVERLAP': 'Overlapped area',
		'PATH_PLANNING.AREA.UNCOVERED': 'Uncovered area',
		'PATH_PLANNING.DETAILS': 'Planned path',
		'PATH_PLANNING.GENERATE_PATH': 'Generate path',
		'PATH_PLANNING.GEOMETRY.CHANGED.QUESTION': 'The field boundary has been changed. Do you want to store the boundary as the current boundary of the field?',
		'PATH_PLANNING.NAME': 'Path planning name',
		'PATH_PLANNING.NAME.EXPLANATION': 'Give the path planning a name',
		'PATH_PLANNING.NOT_ENOUGH_DATA_EXPECTATION': 'Currently there is not enough data to compute the expected fuel consumption, CO2 consumption and cost',
		'PATH_PLANNING.SELECT.FIELD': 'Select the field you want the path to be planned for',
		'PATH_PLANNING.SEND_TO_MACHINE': 'Send to machine',
		'PATH_PLANNING.SETTINGS.CHANGED.QUESTION': 'The settings have been changed after generating the currently shown planned path and will not be reflected when saved. Do you want to continue?',
		'PATH_PLANNING.SUBDIVIDE': 'Subdivide field',
		'PATH_PLANNINGS.DEACTIVATE.FAILURE': 'Some of the planned paths could not be deactivated',
		'PATH_PLANNINGS.DEACTIVATE.QUESTION': 'Do you really want to deactivate the planned path?',
		'PATH_PLANNINGS.DEACTIVATE.SUCCESS': 'Planned paths have been deactivated',
		'PATH_PLANNINGS.DELETE.FAILURE': 'Some of the planned paths could not be deleted',
		'PATH_PLANNINGS.DELETE.QUESTION': 'Do you really want to delete the planned path?',
		'PATH_PLANNINGS.DELETE.SUCCESS': 'Planned paths deleted successfully',
		'PATH_PLANNINGS.MANAGEMENT': 'Planned paths management',
		'PATH_PLANNINGS.NOT_SELECTED': 'No planned path selected',
		'PATH_PLANNINGS.REACTIVATE.FAILURE': 'Some of the planned paths could not be reactivated',
		'PATH_PLANNINGS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected planned paths?',
		'PATH_PLANNINGS.REACTIVATE.SUCCESS': 'Planned paths reactivated successfully',
		'PATTERN': 'Pattern',
		'PATTERN.END_AT_ENTRANCE': 'End at entrance',
		'PATTERN.START': 'Pattern start/end',
		'PATTERN.START_AT_ENTRANCE': 'Start at entrance',
		'PAUSE': 'Pause',
		'PERFORMANCE.AVERAGE': 'Rendimiento medio',
		'PERFORMANCE.AVERAGE.EXPLAINATION': 'Este valor también tiene en cuenta todos los estados de trabajo, incluidos los tiempos de preparación y de carretera',
		'PERFORMANCE.AVERAGE.FIELD': 'Rendimiento promedio (campo)',
		'PERFORMANCE.AVERAGE.FIELD.EXPLAINATION': 'Este valor sólo tiene en cuenta el trabajo en un campo, la espera en un campo y la activación de un campo',
		'PERFORMANCE.TOTAL': 'Rendimiento total',
		'PHONE': 'Teléfono de contacto',
		'PHONE.INVALID': 'Teléfono no válido',
		'PHONE_MOBILE': 'Teléfono (móvil)',
		'PH_VALUE': 'Valor de pH',
		"PLANT_PROTECTANT": "Plaguicida",
		'PLAY': 'Play',
		'POSTCODE': 'Código postal',
		'PREVIOUS': 'Anterior',
		'PROCESS': 'Proceso',
		'PROCESSED': 'Procesado',
		'PROCESSED.FAILURE': 'Fallo durante el procesamiento',
		'PROCESSED.SUCCESSFULL': 'Procesado con éxito',
		'PRODUCT': 'Producto',
		'PROGRESS': 'Progreso',
		'PROJECTION': 'Proyección',
		'RAW_DATA': 'Datos brutos',
		'RECEIVED.AT': 'Recibido en',
		'REGENERATE': 'Regenerar',
		'REGENERATE.SELECTED': 'Regenerar seleccionado',
		'REGISTER': 'Regístrese ',
		'REGISTER.ALREADY_REGISTERED?': '¿Ya se ha registrado?',
		'REGISTER.I_ACCEPT_THE': 'Acepto los',
		'RELOAD': 'Recargar',
		'REMOVE': 'Eliminar',
		'RENEW': 'Renovar',
		'REOCURRING': 'Recurrente',
		'REPORT': 'Informe',
		'RESET': 'Restablecer',
		'RESOLUTION': 'Resolución',
		'RESTORE.DRIVER': 'Restaurar conductor',
		'RESTORE.IMPLEMENT': 'Restaurar implemento',
		'ROAD': 'Ruta',
		'ROLE': 'Rol ',
		'RUNTIME_H': 'Tiempo de ejecución en h',
		'SAFETY_CHECK': 'Comprobar seguridad',
		'SATELITE': 'Satélite',
		'SAVE': 'Guardar',
		'SCALE.TYPE': 'Tipo de escala',
		'SEARCH': 'Buscar ',
		'SEASON_YEAR': 'Temporada',
		'SEASON_YEAR.START': 'Inicio de temporada',
		'SELECT.ALL': 'Seleccionar todo',
		'SELECT.CLEAR': 'Eliminar selección',
		'SELECT.FIELD': 'Select field',
		'SENSORDATA': 'Datos de los sensores',
		'SENSORDATA.DESCRIPTION': 'Visualización de datos sensoriales',
		'SENSORDATA.SELECT_SENSOR': 'Seleccionar sensor',
		'SENSORDATA.SHOW_WORKSTATE_COLORS': 'Mostrar colores del estado de trabajo',
		'SENSOR_PARAMETER': 'Parámetro del sensor',
		'SENSOR_PARAMETER.ADD': 'Añadir parámetro de sensor',
		'SENSOR_PARAMETER.DEFINE_FOR_IMPLEMENT': 'Definir parámetros de sensores individuales para el implemento seleccionado.',
		'SENSOR_PARAMETER.DEFINE_INDIVIDUAL_PARAM': 'Defina el parámetro individual de su sensor.',
		'SENSOR_PARAMETER.INDIVIDUAL_SENSOR_PARAM': 'Parámetro de sensor individual',
		'SENSOR_PARAMETER.NOT_REMOVABLE_USED_IN_OTHER_PARAMETER': 'El parámetro del sensor se utiliza en otra configuración de parámetros',
		'SENSOR_PARAMETERS': 'Parámetros de los sensores',
		'SENSOR_PARAMETERS.NO': 'Sin parámetros de sensor',
		'SERIAL': 'Número de serie',
		'SETTINGS': 'Ajustes',
		'SETTINGS.ADDITIONAL': 'Additional settings',
		'SETTINGS.ADVANCED': 'Advanced settings',
		'SETTINGS.AGRIROUTER_CAN_BE_CONNECTED': 'Su cuenta Agrirouter puede conectarse a exatrek para compartir datos.',
		'SETTINGS.AGRIROUTER_CONNECTED_AND_READY': 'Agrirouter está conectado y listo para su uso. La conexión es válida hasta que',
		'SETTINGS.CONNECTION_TO_PARTNERS': 'Conxión con socios de exatrek ',
		'SETTINGS.FARMNET_FIELD_SYNC': 'Sincronizar los campos de 365Farmnet a Exatrek',
		'SETTINGS.FARMNET_IMPLEMENT_SYNC': 'Sincronizar implementos de 365farmnet a exatrek',
		'SETTINGS.FARMNET_MACHINE_SYNC': 'Sincronizar máquinas de 365Farmnet a Exatrek',
		'SETTINGS.GO_TO_FARMNET': 'IR A 365 FARMNET',
		'SETTINGS.ONLY_FARMNET_WEBAPP': 'La sincronización de y para 365Farmnet solo puede ser usada de la Webapp de 365Farmnet',
		'SHOW': 'Mostrar',
		'SHOW_DIRECTION': 'Mostrar direcciones',
		'SHOW_EVENTS': 'Mostrar eventos',
		'SHOW_FIELDS': 'Mostrar campos',
		'SHOW_LOCATIONS': 'Mostrar lugares',
		'SHOW_OFFLINE_MACHINES': 'Mostrar máquinas desconectadas',
		'SHOW_TRACKS': 'Mostrar caminos',
		'SHOW_TRACKS_': 'Mostrar caminos',
		'SNACKBAR.DAYS': 'días',
		'SNACKBAR.LICENSE_EXPIRATION_WARNING': 'Su licencia caduca en',
		'SNACKBAR.MACHINE_ONLINE_WARNING': 'Al menos una máquina lleva tiempo sin conectarse.',
		'SORT_BY': 'Ordenar por',
		'SPEED': 'Velocidad',
		'SPEED.AVERAGE': 'Velocidad media',
		'SPEED.FASTER': 'Faster',
		'SPEED.RESET': 'Reset speed',
		'SPEED.SIGNAL.OVERRIDE': 'Anulación de la señal de velocidad',
		'SPEED.SLOWER': 'Slower',
		'SPEED.WORKING': 'Working speed',
		'SPLIT': 'Dividir',
		'START': 'Inicio',
		'STATISTICS': 'Statistics',
		'STATUS': 'Estado',
		'STOP': 'Fin ',
		'STORAGE': 'Almacenamiento',
		'STORAGE.USB': 'Almacenamiento USB',
		'STORAGE.USB.USED': 'Almacenamiento USB en uso',
		'STORAGE.USED': 'Almacenamiento en uso',
		'SYMBOLIZATION': 'Simbolización',
		'TASK': 'Tarea',
		'TASK.ADDABLE_JOBS': 'Trabajos añadibles',
		'TASK.ADD_JOBS': 'Añadir trabajos a la tarea',
		'TASK.ARCHIVED_JOB_WARNING': 'Esta tarea contiene trabajos archivados y no se mostrará en su totalidad.',
		'TASK.DELETE.JOB.FAILURE': 'Una tarea debe contener al menos un trabajo.',
		'TASK.DELETE.JOB.QUESTION': '¿Realmente desea eliminar el trabajo de la tarea?',
		'TASK.DELETE.JOB.SUCCESS': 'Trabajo eliminado correctamente de la tarea',
		'TASK.DELETE.QUESTION': '¿Realmente desea eliminar la tarea?',
		'TASK.DELETE.SUCCESS': 'Tarea eliminada correctamente',
		'TASK.EDIT': 'Editar tarea',
		'TASK.EDIT.SUCCESS': 'Tarea editada correctamente',
		'TASK.EXPORT_DETAILS': 'Exportar la tarea seleccionada',
		'TASK.JOBS_TO_ADD': 'Trabajos por añadir',
		'TASK.NEW': 'Nueva tarea',
		'TASKS': 'Tareas',
		'TASKS.NO': 'Sin tareas',
		'TASK_CONTROLLER.ACTIVE': 'Modo de compatibilidad de controlador de tareas activo (DataLog)',
		'TASK_CONTROLLER.COMPAT_ACTIVE': 'Modo de compatibilidad de controlador de tareas activo',
		'TAX_ID': 'Tax ID',
		'TC': 'Controlador de tareas',
		'TC.ACTIVE': 'Controlador de tareas activo',
		'TC.TC_COMP': 'Controlador de tareas  comp.',
		'TERMINAL.NO': 'Sin terminal',
		'TERMINAL.TYPE': 'Tipo de terminal',
		'TEST.SUCCESS': 'Solicitud aceptada. En breve recibirá un correo electrónico.',
		'TIME': 'Tiempo',
		'TIME.REMAINING': 'Tiempo restante',
		'TIMEZONE': 'Zona horaria',
		'TITLE': 'Solicitar cuenta de prueba',
		'TOKEN': 'Código de acceso',
		'TOTAL': 'Total',
		'TRACKS.LOADING': 'Cargando caminos...',
		'TRACK.WIDTH': 'Anchura de la vía',
		'TRACK.WIDTH.NARROW': 'Angosto',
		'TRACK.WIDTH.NORMAL': 'Normal',
		'TRACK.WIDTH.WIDE': 'Ancho',
		'TRACK_LENGTH': 'Longitud de la vía',
		'TRACK_REPLAY': 'Track replay',
		'TRANSLATABLE': 'Traducible',
		'TRANSLATABLE.ADD': 'Añadir traducible',
		'TRANSLATION': 'Traducción',
		'TRANSPORT': 'Transporte',
		'TRANSPORT/AXLES': 'Transporte/Ejes',
		'TRANSPORTAMOUNT_AXLES': 'Transporte cantidad/Ejes',
		'TURNINGS': 'Turnings',
		'TURNING_OFFSET': 'Turning offset',
		'TURNING_RADIUS': 'Turning radius',
		'TYPE': 'Tipo',
		'UNDO': 'Deshacer',
		'UNIT': 'Unidad',
		'UNKNOWN': 'Desconocido',
		'UNTIL': 'hasta',
		'UPLOAD': 'Cargar',
		'UPLOAD.FINISHED': 'Carga finalizada',
		'UPLOADING': 'Cargar',
		'USER.EDIT.SUCCESS': 'Usuario editado correctamente',
		'USERNAME': 'Usuario',
		'USERNAME.LENGTH.REQUIRED': 'El nombre de usuario debe tener al menos 6 caracteres',
		'USERNAME.TAKEN': 'Este nombre ya está cogido.',
		'USERNAME.VALID.CHARS': 'El nombre de usuario sólo puede contener letras, números, \"-\" y \"_\".',
		'USERROLE': 'Función del usuario',
		'USERSTATUS': 'Estado del usuario',
		'USER_CREATED': 'Usuario creado',
		'WAITING': 'Parado',
		'WARNING': 'Advertencia',
		'WEEK.CURRENT': 'Semana actual',
		'WEEK.NEXT': 'Próxima semana',
		'WEEK.PREVIOUS': 'Semana previa ',
		'WEEK.SELECTED': 'Semana seleccionada',
		'WEIGHING': 'Pesar',
		'WIDTH.INVALID': 'Ancho no válido',
		'WORKING_HOURS': 'Horario de trabajo',
		'WORKING_TIME': 'Tiempo de trabajo',
		'WORKING_WIDTH': 'Ancho de trabajo',
		'WORKSTATE': 'Estado de trabajo',
		'WORKSTATES': 'Estados de trabajo',
		'YES': 'Sí',
    'NO_POSITION_MACHINE_FOUND': 'No se ha encontrado ninguna posición para esta maquina',
	}
};
